import react from 'react'
import { userStore, UserState } from '../api/AuthService';
import { DriverProfile } from '../api/model/DriverProfile';

const today = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)

export const LeaseAgreementModule = (props: { ownerData?: any, unitData?: any, tierTable?: any, mileageStatement?: any, nextFriday?: any, viewObject?: any, signatureData?: any, date?: any, year?: any }) => {

  const {userInfo}: { userInfo: DriverProfile } = userStore((state: UserState) => ({userInfo: state.driver}));

  let currentDate = today.toISOString().split('T')[0]
  let currentYear = currentDate.slice(2, 4);

  console.log("viewObj", props.viewObject === undefined)

  return <div>
    <title>Lease Agreement 2024</title>
    <style
      type="text/css"
      dangerouslySetInnerHTML={{
        __html:
          ' * {margin:0; padding:0; text-indent:0; }\n .s1 { color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 10pt; }\n h1 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 14pt; }\n .p, p { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; margin:0pt; }\n .s2 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 10pt; }\n .s4 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; vertical-align: 1pt; }\n .s5 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s6 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: underline; font-size: 10pt; }\n .h4, h4 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s7 { color: black; font-family:Arial, sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s8 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 6.5pt; vertical-align: 3pt; }\n .s9 { color: black; font-family:Arial, sans-serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s10 { color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 11pt; }\n .s11 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 12pt; }\n .s12 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n h2 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: underline; font-size: 12pt; }\n .s13 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n .s14 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .s15 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; vertical-align: -1pt; }\n .s16 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 7pt; vertical-align: 3pt; }\n .s18 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; vertical-align: -3pt; }\n .s19 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s20 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s21 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s22 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .s23 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 11pt; }\n .s24 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n h3 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n .s26 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: underline; font-size: 11pt; }\n .s27 { color: black; font-family:Wingdings; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n li {display: block; }\n #l1 {padding-left: 0pt;counter-reset: c1 1; }\n #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }\n #l2 {padding-left: 0pt;counter-reset: c2 1; }\n #l2> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l2> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l3 {padding-left: 0pt;counter-reset: c3 1; }\n #l3> li>*:first-child:before {counter-increment: c3; content: "("counter(c3, lower-roman)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l3> li:first-child>*:first-child:before {counter-increment: c3 0;  }\n #l4 {padding-left: 0pt;counter-reset: c2 1; }\n #l4> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l4> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l5 {padding-left: 0pt;counter-reset: c2 1; }\n #l5> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l5> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l6 {padding-left: 0pt;counter-reset: c2 1; }\n #l6> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l6> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l7 {padding-left: 0pt;counter-reset: c3 1; }\n #l7> li>*:first-child:before {counter-increment: c3; content: "("counter(c3, lower-roman)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l7> li:first-child>*:first-child:before {counter-increment: c3 0;  }\n #l8 {padding-left: 0pt;counter-reset: c2 1; }\n #l8> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l8> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l9 {padding-left: 0pt;counter-reset: c2 1; }\n #l9> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l9> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l10 {padding-left: 0pt;counter-reset: c3 1; }\n #l10> li>*:first-child:before {counter-increment: c3; content: "("counter(c3, lower-roman)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l10> li:first-child>*:first-child:before {counter-increment: c3 0;  }\n #l11 {padding-left: 0pt;counter-reset: c2 1; }\n #l11> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l11> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l12 {padding-left: 0pt;counter-reset: c2 1; }\n #l12> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l12> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l13 {padding-left: 0pt;counter-reset: c2 1; }\n #l13> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l13> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l14 {padding-left: 0pt;counter-reset: c3 1; }\n #l14> li>*:first-child:before {counter-increment: c3; content: "("counter(c3, lower-roman)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l14> li:first-child>*:first-child:before {counter-increment: c3 0;  }\n #l15 {padding-left: 0pt;counter-reset: c2 1; }\n #l15> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l15> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l16 {padding-left: 0pt;counter-reset: c2 1; }\n #l16> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l16> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l17 {padding-left: 0pt;counter-reset: c2 1; }\n #l17> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l17> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l18 {padding-left: 0pt;counter-reset: c3 1; }\n #l18> li>*:first-child:before {counter-increment: c3; content: "("counter(c3, lower-roman)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l18> li:first-child>*:first-child:before {counter-increment: c3 0;  }\n #l19 {padding-left: 0pt;counter-reset: d1 1; }\n #l19> li>*:first-child:before {counter-increment: d1; content: counter(d1, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l19> li:first-child>*:first-child:before {counter-increment: d1 0;  }\n #l20 {padding-left: 0pt;counter-reset: d2 1; }\n #l20> li>*:first-child:before {counter-increment: d2; content: counter(d2, lower-latin)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l20> li:first-child>*:first-child:before {counter-increment: d2 0;  }\n #l21 {padding-left: 0pt;counter-reset: c2 1; }\n #l21> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l21> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l22 {padding-left: 0pt;counter-reset: c2 1; }\n #l22> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l22> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l23 {padding-left: 0pt;counter-reset: c2 1; }\n #l23> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l23> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l24 {padding-left: 0pt;counter-reset: c3 1; }\n #l24> li>*:first-child:before {counter-increment: c3; content: "("counter(c3, lower-roman)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l24> li:first-child>*:first-child:before {counter-increment: c3 0;  }\n #l25 {padding-left: 0pt;counter-reset: c4 1; }\n #l25> li>*:first-child:before {counter-increment: c4; content: "("counter(c4, decimal)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l25> li:first-child>*:first-child:before {counter-increment: c4 0;  }\n #l26 {padding-left: 0pt;counter-reset: c4 1; }\n #l26> li>*:first-child:before {counter-increment: c4; content: "("counter(c4, decimal)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l26> li:first-child>*:first-child:before {counter-increment: c4 0;  }\n #l27 {padding-left: 0pt;counter-reset: e1 1; }\n #l27> li>*:first-child:before {counter-increment: e1; content: "("counter(e1, lower-roman)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l27> li:first-child>*:first-child:before {counter-increment: e1 0;  }\n #l28 {padding-left: 0pt;counter-reset: e2 1; }\n #l28> li>*:first-child:before {counter-increment: e2; content: "("counter(e2, decimal)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l28> li:first-child>*:first-child:before {counter-increment: e2 0;  }\n #l29 {padding-left: 0pt;counter-reset: e2 1; }\n #l29> li>*:first-child:before {counter-increment: e2; content: "("counter(e2, decimal)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l29> li:first-child>*:first-child:before {counter-increment: e2 0;  }\n #l30 {padding-left: 0pt;counter-reset: c2 1; }\n #l30> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l30> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l31 {padding-left: 0pt;counter-reset: c3 1; }\n #l31> li>*:first-child:before {counter-increment: c3; content: "("counter(c3, lower-roman)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l31> li:first-child>*:first-child:before {counter-increment: c3 0;  }\n #l32 {padding-left: 0pt;counter-reset: c2 1; }\n #l32> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l32> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l33 {padding-left: 0pt;counter-reset: c2 1; }\n #l33> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l33> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l34 {padding-left: 0pt;counter-reset: c2 1; }\n #l34> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l34> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l35 {padding-left: 0pt;counter-reset: c3 1; }\n #l35> li>*:first-child:before {counter-increment: c3; content: "("counter(c3, lower-roman)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l35> li:first-child>*:first-child:before {counter-increment: c3 0;  }\n #l36 {padding-left: 0pt;counter-reset: c4 1; }\n #l36> li>*:first-child:before {counter-increment: c4; content: "("counter(c4, decimal)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l36> li:first-child>*:first-child:before {counter-increment: c4 0;  }\n #l37 {padding-left: 0pt;counter-reset: c2 1; }\n #l37> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l37> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l38 {padding-left: 0pt;counter-reset: c2 1; }\n #l38> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l38> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n li {display: block; }\n #l39 {padding-left: 0pt;counter-reset: f1 1; }\n #l39> li>*:first-child:before {counter-increment: f1; content: counter(f1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n #l39> li:first-child>*:first-child:before {counter-increment: f1 0;  }\n #l40 {padding-left: 0pt;counter-reset: f2 1; }\n #l40> li>*:first-child:before {counter-increment: f2; content: counter(f2, upper-latin)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n #l40> li:first-child>*:first-child:before {counter-increment: f2 0;  }\n li {display: block; }\n #l41 {padding-left: 0pt;counter-reset: g1 1; }\n #l41> li>*:first-child:before {counter-increment: g1; content: counter(g1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n #l41> li:first-child>*:first-child:before {counter-increment: g1 0;  }\n li {display: block; }\n #l42 {padding-left: 0pt;counter-reset: h1 1; }\n #l42> li>*:first-child:before {counter-increment: h1; content: counter(h1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n #l42> li:first-child>*:first-child:before {counter-increment: h1 0;  }\n #l43 {padding-left: 0pt;counter-reset: h2 1; }\n #l43> li>*:first-child:before {counter-increment: h2; content: counter(h2, lower-latin)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l43> li:first-child>*:first-child:before {counter-increment: h2 0;  }\n #l44 {padding-left: 0pt;counter-reset: h3 1; }\n #l44> li>*:first-child:before {counter-increment: h3; content: counter(h3, lower-roman)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l44> li:first-child>*:first-child:before {counter-increment: h3 0;  }\n #l45 {padding-left: 0pt;counter-reset: h2 1; }\n #l45> li>*:first-child:before {counter-increment: h2; content: counter(h2, lower-latin)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n #l45> li:first-child>*:first-child:before {counter-increment: h2 0;  }\n #l46 {padding-left: 0pt;counter-reset: i1 1; }\n #l46> li>*:first-child:before {counter-increment: i1; content: counter(i1, upper-roman)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n #l46> li:first-child>*:first-child:before {counter-increment: i1 0;  }\n #l47 {padding-left: 0pt;counter-reset: i2 5; }\n #l47> li>*:first-child:before {counter-increment: i2; content: counter(i2, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n #l47> li:first-child>*:first-child:before {counter-increment: i2 0;  }\n table, tbody {vertical-align: top; overflow: visible; }\n'
      }}
    />
    <div
      className="textbox"
      style={{
        border: "0.8pt solid #000000",
        display: "block",
        minHeight: "33.8pt",
        width: "465.8pt"
      }}
    >
      <p
        className="s1"
        style={{
          paddingTop: "3pt",
          paddingLeft: "22pt",
          textIndent: "-10pt",
          textAlign: "left"
        }}
      >
        This lease may have been collaterally assigned to a secured party, and if
        so, any purchase or assignment of this lease would violate the rights of
        the secured party. Inquire with Lessor if you have any questions.
      </p>
    </div>
    <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }} />
    <h1 style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "center" }}>
      LEASE AGREEMENT WITH OPTION TO PURCHASE
    </h1>
    <p
      style={{
        paddingTop: "12pt",
        paddingLeft: "6pt",
        textIndent: "0pt",
        lineHeight: "11pt",
        textAlign: "left"
      }}
    >
      THIS LEASE AGREEMENT WITH OPTION TO PURCHASE (the “Agreement”) is made by
      and between
    </p>
    <p
      style={{
        paddingLeft: "6pt",
        textIndent: "0pt",
        lineHeight: "94%",
        textAlign: "left"
      }}
    >
      <span className="s2"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
      <u>
        New Horizons Leasing
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      <span className="s4">
        with principal offices at 7135 Centennial Place, Nashville, TN 37209
        (hereinafter
      </span>
      “Lessor”, “WE”, “US” or “OUR”), and
      <span className="s2">
      { props.viewObject !== undefined ? props.viewObject.OwnerName1 : props.ownerData.name }
      </span>
      <span className="s5"> </span>with mailing address or principal offices at
    </p>
    <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      <span className="s2">
        {props.viewObject !== undefined ? props.viewObject.OwnerAddress1 : (props.ownerData!.address + " " + props.ownerData!.city + " " + props.ownerData!.state)}
      </span>
      (hereinafter “Lessee”, “YOU” or “YOUR”).
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      In consideration of the mutual promises contained in this Agreement, the
      parties agree as follows:
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <ol id="l1">
      <li data-list-text={1}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Lease Documents</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l2">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Scope.
              <span className="p">
                The following agreements and documents shall constitute the “Lease
                Documents,” each of which shall be incorporated herein as if a
                part of this Agreement:
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l3">
              <li data-list-text="(i)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  this Lease Agreement with Option to Purchase, together with
                  Schedules and attachments hereto, including without limitation
                  the Schedule A (Vehicle Terms and Payments), Schedule B (Motor
                  Carrier Authority), and, as applicable, Schedule C (Short Term
                  Tractor Rental), and
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(ii)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  any other agreements that by their nature implement or carry out
                  the terms of Section 4 (Payments) or Section 5 (Option to
                  Purchase Vehicle) below.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Integration.
              <span className="p">
                This Agreement, together with the other Lease Documents, reflects
                the entire understanding of the parties with respect to the
                transactions contemplated hereby and shall not be contradicted or
                qualified by any other agreement, oral or written, before the
                execution of such Lease Document.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={2}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Vehicle</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l4">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Purpose.
              <span className="p">
                WE will lease to YOU the vehicle described on the attached
                Schedule A, together with all present and future attachments,
                accessories, replacement parts, and additions thereto, as
                permitted hereunder, including without limitation tires, brakes,
                and any other equipment required to render such vehicle usable
                (collectively the “Vehicle”) for the sole purpose of engaging in
                the independent business of operating the Vehicle within the
                United States in compliance with all applicable law, regulations,
                rules and ordinances, for motor carrier companies, as listed on
                Schedule B (as may be amended) (the “Carrier(s)”) (the “Purpose”).
                Use of the Vehicle for any purpose other than the foregoing
                Purpose shall be an unauthorized use. Without limiting the
                foregoing, Vehicle shall not be used in the transportation of
                radioactive materials, hazardous waste, or explosives, unless WE
                have expressly approved the transportation of such material in
                advance, in writing, and appropriate insurance is in place.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Inspection; Acceptance.
              <b>
                By signing this Agreement and by operating the Vehicle, YOU
                acknowledge and agree that YOU have the opportunity to inspect the
                Vehicle prior to signing this Agreement and that the Vehicle is
                acceptable to YOU. By accepting the Vehicle, YOU agree and
                acknowledge that the Vehicle is in good operating order, repair
                and appearance.
              </b>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Responsibility.
              <span className="p">
                YOU are solely responsible for any loss, theft or damage to the
                Vehicle for any reason during the Term, which may result in
                periods of time while the Vehicle is being repaired or is
                otherwise not in service (“Downtime”). In the event that YOU
                experience a period of Downtime, you may, subject to availability,
                elect to enter into a Short Term Tractor Rental Agreement with
                Lessor in the form of Schedule C, subject to all terms and
                conditions of the Lease Documents.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Protection of the Vehicle.
              <span className="p">
                Any contrary provision of this Lease or any other Lease Document
                notwithstanding, Lessor is hereby authorized by you, from time to
                time in Lessor’s sole discretion, to advance funds or make direct
                payments to third parties that Lessor deems necessary or desirable
                to preserve and protect the Vehicle, or any portion thereof, or to
                enhance the likelihood of your satisfaction of the obligations
                hereunder. You are responsible for reimbursement to US of such
                reasonable amounts as set forth herein, including without
                limitation pursuant to Sections 4(c), 7, 9 and 16 below.
              </span>
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={3}>
        <p
          style={{
            paddingTop: "3pt",
            paddingLeft: "23pt",
            textIndent: "-17pt",
            textAlign: "left"
          }}
        >
          <u>
            <b>Term; Walk-Away Lease</b>
          </u>
          .
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l5">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Term
              <span className="p">
                . The lease term for the Vehicle shall be for the period of weeks
                set forth on Schedule A hereto (subject to (i) earlier termination
                as a result of either YOUR termination pursuant to Section 3(b)
                below or an Event or Default under Section 19, or (ii) extension
                pursuant to Section 4(d) below, the “Term”).
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Walk-Away Lease
              <span className="p">
                . You may terminate this Agreement at any time on five (5) days’
                advance written notice and returning the Vehicle at Trade Terms
                (as defined in Section 9(b) below), with the effective date of
                such termination being the later of the satisfaction of the
                foregoing conditions (the “Termination Date”). In such case, YOU
                will be responsible for all Base Payments, Mileage Payments, and
                Additional Payments that have accrued or arise from your
                obligations hereunder through the Termination Date or result from
                such termination. For clarity and purposes of this Section 3(b),
                Additional Payments as provided in Section 4(c) shall include
                without limitation the costs, fees and charges set forth in
                Sections 2(d) (Protection of the Vehicle), 4(d) (Deferments) 9(c)
                (Return Costs/Fees), and 16 (Indemnity), in each case arising from
                such termination and regardless of timing. In other words, by way
                of clarity and without limiting the foregoing, you may exercise
                your rights under this Section 3(b) to walk away from the FUTURE
                obligations of the Lease Documents by providing notice, making
                payment of current charges and fees having accrued in connection
                with the termination, and turning in the Vehicle at Trade Terms.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={4}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Payments</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l6">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Base Payments.
              <span className="p">
                You shall make base lease payments in the amount and at the
                frequency indicated on Schedule A (“Base Payments”); provided,
                that Base Payments, regardless of whether this Agreement is
                formally terminated, shall not be due and shall cease to accrue
                upon the later of (i) Lessor’s obtaining possession of the Vehicle
                (either as a result of YOUR termination of this Agreement pursuant
                to Section 3(b) or as a result of an Event of Default), and (ii)
                return of the Vehicle to Trade Terms. Typically, these are weekly
                payments taken out your revenues. Such Base Payments are deemed
                late when not received within (5) days of the due date.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Mileage Payment
              <span className="p">
                . You shall make reimbursements to US for advance depreciation in
                the amount and frequency indicated on Schedule A (“Mileage
                Payment”). Such Mileage Payments are deemed late when not received
                within five (5) days of the due date.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Additional Payments.
              <span className="p">
                Unless otherwise agreed to by US in advance in form and substance
                acceptable to US, any amounts other than Base Payments or Mileage
                Payments that may become due hereunder, or pursuant to any other
                Lease Document, (“Additional Payments”) shall be paid at the time
                of the next scheduled Base Payment, or if no such Base Payment is
                scheduled, upon demand. Such Additional Payments are deemed late
                when not received within five (5) days of the due date.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Deferments; Payment Plans
              <span className="p">
                . You may apply to have certain payments deferred or otherwise
                adjusted as set forth below, and the process for your application
                for such deferments may be found within the mobile driver
                application or from your dispatch agent. We will review all
                applications for deferred or adjusted payments, which may be
                approved or denied by us in our discretion, in consideration of
                the applicable facts and circumstances and on a case- by-case
                basis, and may be subject to terms and conditions that may change
                from time to time without advance notice. The parties shall
                document any deferments, the forms for which may be adjusted from
                time to time in our discretion. Any payments deferred pursuant to
                this Section 4(d) shall constitute a “Deferred Payment.”
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l7">
              <li data-list-text="(i)">
                <p
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "36pt",
                    textAlign: "justify"
                  }}
                >
                  Initial Base Payments. As a courtesy, the first two (2) weekly
                  Base Payments (the “Initial Base Payments”) are automatically
                  deferred upon execution of this Agreement. For the avoidance of
                  doubt, these deferred Initial Base Payments are subject to the
                  terms and conditions contained in this Section 4(d). You may
                  elect to waive deferment of the Initial Base Payments by
                  providing Notice to US pursuant to Section 35 of this Agreement,
                  prior to the date of the 1<span className="s8">st </span>Lease
                  Payment contained in Schedule A.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(ii)">
                <p
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "36pt",
                    textAlign: "justify"
                  }}
                >
                  Base Payments. Should you be unable to make any Base Payment
                  timely, you may apply to have such Base Payments deferred. If
                  approved, such deferment shall (A) extend the Term by one week
                  from the currently scheduled end date of the Lease, and (B)
                  defer the due date of such deferred Base Payment until the
                  earliest of: (1) the occurrence of an Event of Default, at which
                  point the aggregate of all such deferred Base Payments shall be
                  immediately due and payable, (2) YOUR termination of this
                  Agreement pursuant to Section 3(b) above, at which point the
                  aggregate amount of all such deferred Base Payments shall be
                  immediately due and payable, (3) the satisfaction of the
                  requirements set forth in Section
                </p>
                <p
                  style={{
                    paddingTop: "3pt",
                    paddingLeft: "36pt",
                    textIndent: "0pt",
                    textAlign: "justify"
                  }}
                >
                  18(b) to haul for a New Carrier, at which point the aggregate
                  amount of all such deferred Base Payments shall be immediately
                  due and payable or (4) the subsequent due date for Base Payments
                  as extended by this Section 4(d)(i). The current form of such
                  deferral is included as Schedule D hereto.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(iii)">
                <p
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "36pt",
                    textAlign: "justify"
                  }}
                >
                  Additional Payments. Should you be unable to make timely
                  Additional Payments, you may apply to have such Additional
                  Payments deferred or satisfied through an agreed-upon payment
                  plan. Each approved deferment or payment plan shall (A) be
                  subject to the terms and conditions of a written agreement or
                  acknowledgement by you regarding such deferred Additional
                  Payment, and (B) defer the due date of such deferred Additional
                  Payment until the earliest of: (A) the occurrence of an Event of
                  Default, at which point the aggregate of the outstanding amount
                  of all such deferred Additional Payments shall be immediately
                  due and payable, (B) YOUR termination of this Agreement pursuant
                  to Section 3(b) above, at which point the aggregate of the
                  outstanding amount of all such deferred Additional Payments
                  shall be immediately due and payable, (C) the satisfaction of
                  the requirements set forth in 18(b) to haul for a New Carrier,
                  at which point the aggregate of the outstanding amount of all
                  such deferred Additional Payments shall be immediately due and
                  payable, or (D) the subsequent due dates set forth in the
                  applicable deferment or payment plan. The current form of such
                  deferral is included as Schedule E hereto.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="(e)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Authorization for Deduction.
              <b>
                YOU AGREE AND HEREBY DO AUTHORIZE AND DIRECT CARRIER TO MAKE
                DEDUCTIONS FROM CONTRACT SETTLEMENTS OR ANY ESCROWED FUNDS IN
                ORDER TO PAY BASE PAYMENTS, MILEAGE PAYMENTS, ADDITIONAL PAYMENTS,
                AND DEFERRED PAYMENTS (pursuant to the
              </b>
            </p>
            <h4
              style={{
                paddingLeft: "24pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              terms of such deferral).
            </h4>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(f)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Responsibility.
              <span className="p">
                Regardless of any Downtime or other interruption in your
                operations for any reason, you acknowledge and agree that you will
                continue to be responsible for the Base Payments, Mileage
                Payments, Additional Payments, and Deferred Payments hereunder,
                which payments Lessor shall be entitled to continue to bill,
                subject to any adjustment pursuant to Section 4(d) above.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={5}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Option to Purchase Vehicle</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l8">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Exercise of Option.
              <span className="p">
                Provided YOU are current in YOUR obligations under this Agreement
                and are not in default of the Agreement in any respect, YOU may
                purchase the Vehicle during the Term by making payment to US of
              </span>
            </p>
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              (i) the net present value of any remaining or outstanding Base
              Payments, Additional Payments, and Deferred Payments, if any, plus
              (ii) the Purchase Price as defined by Schedule A to this Agreement.
              You acknowledge and agree that this option and purchase price
              formula implements the benefit of the bargain intended between the
              parties, represents a reasonable calculation of such bargain at the
              time of execution of this Agreement, and does not serve as a
              penalty.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Additional Conditions.
              <span className="p">
                Upon consummation of YOUR purchase of the Vehicle, title to the
                Vehicle will be transferred to YOU as soon as WE are reasonably
                able. By virtue of this Agreement, YOU appoint US as YOUR
                attorney-in-fact to take any actions necessary to transfer title
                to the Vehicle to YOU. If YOU do purchase the Vehicle, WE make no
                warranties of any kind, expressed or implied, with respect to the
                Vehicle or YOUR intended use of it. The Vehicle will be sold and
                transferred to YOU on an “AS IS, WHERE IS” basis. Any applicable
                purchase agreement or bill of sale shall contain other and further
                customary terms for transactions of this type.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={6}>
        <h4
          style={{ paddingLeft: "24pt", textIndent: "-18pt", textAlign: "left" }}
        >
          <u>Representations and Warranties by Lessee</u>.
          <span className="p">
            You hereby represent and warrant, and acknowledge that such
            representations and warranties are material to Lessor’s entry into,
            and performance under, this Agreement, that
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l9">
          <li data-list-text="(a)">
            <p
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                textAlign: "left"
              }}
            >
              you or any other operator of the Vehicle hereunder have requisite
              knowledge and experience regarding:
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l10">
              <li data-list-text="(i)">
                <p
                  style={{
                    paddingLeft: "50pt",
                    textIndent: "-17pt",
                    textAlign: "left"
                  }}
                >
                  the operation of the Vehicle for the Purpose, and
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(ii)">
                <p
                  style={{
                    paddingLeft: "50pt",
                    textIndent: "-18pt",
                    textAlign: "left"
                  }}
                >
                  the applicable laws, regulations and ordinances (including
                  without limitation the Federal Motor Carrier Safety
                  Regulations);
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              you have entered into a lease with a motor carrier authorized to
              engage in the transportation of property (as specified in Schedule B
              or as otherwise provided under this Agreement, and pursuant to 49
              C.F.R. § 376.11 and 376.12), who possesses sufficient financial
              solvency and access to freight requiring transportation, such that
              Lessor is adequately assured of your ability to satisfy the
              obligations under this Agreement;
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              style={{
                paddingTop: "3pt",
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              prior operation of, or hauling of freight using, any vehicle under
              your custody or control has (i) been in compliance with applicable
              laws, regulations and ordinances, and (ii) been in compliance with
              applicable agreements or contracts, and (iii) not given rise to any
              claims or liability that remains outstanding as of the date hereof,
              except in each case as may be disclosed in writing to Lessor prior
              to execution of this Agreement;
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              except as stated in this Agreement, YOU have not prepaid any lease
              or rental payments or other monies owing under this Agreement, and
              no deposits have been made;
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(e)">
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              no assignee has assumed and no assignee will have any obligations or
              liabilities under this Agreement, to YOU or to any other person for
              any reason; and
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(f)">
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              you have had an adequate opportunity to review the Lease Documents
              with counsel and have done so, or chosen not to do so.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={7}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Maintenance and Repairs</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l11">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Responsibility.
              <span className="p">
                YOU are responsible, at your own cost and expense for the service,
                maintenance and repair of the Vehicle for any reason whatsoever so
                as to keep the Vehicle in as good condition, repair, appearance
                and working order as when delivered to you, reasonable wear and
                tear excepted. Without limiting the foregoing, such obligations
                include furnishing all motor oil and lubricants, labor, parts,
                supplies, tires, tire service, road service, winterizing,
                greasing, changing air and oil filters, washing, and other
                materials and service (in compliance with any applicable
                manufacturer’s warranty) to enable you to conduct normal business
                operations and keep the Vehicle in good condition and that you may
                return it at Trade Terms pursuant to the terms hereunder. YOU
                shall replace at YOUR sole cost and expense any and all parts,
                mechanisms and devices that may, from time to time, become worn
                out, non-operational, lost, stolen, destroyed, damaged beyond
                repair, or rendered unfit for use, for any reason whatsoever. All
                such replacement parts, mechanisms, and devices shall: (i) be free
                and clear of all liens, encumbrances, and rights of others, (ii)
                become OUR property, unless and until you purchase the Vehicle,
                (iii) become incorporated into the definition of Vehicle in
                Section 2 and Schedule A of this Agreement, (iv) be covered by
                this Agreement, and (v) comply with the manufacturer’s warranty
                requirements.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Insurance.
              <span className="p">
                The costs and expenses of service, repair, and maintenance shall
                be in addition to any charges or deductible for which YOU are
                responsible resulting from a claim of loss or damage under any
                policy of insurance required by this Agreement.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Satisfaction from Escrow Fund.
              <span className="p">
                Should you incur maintenance, repair or insurance expenses in
                excess of the regularly scheduled settlements, and you do not
                direct us otherwise, WE may, in accordance with Section 13 below,
                utilize your Escrow Fund or future settlements to satisfy any such
                expenses you do not pay out of pocket.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Accident Reporting
              <span className="p">
                . To insure maintenance of good condition of the Vehicle and any
                other equipment of OURS, YOU shall immediately report any and all
                accidents to US irrespective of the amount of apparent damage
                caused by said accident.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={8}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Licenses, Permits and Taxes</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l12">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Assessments.
              <span className="p">
                YOU will be responsible for paying the cost of any licenses,
                permits, base plates and other items necessary to operate the
                Vehicle and any taxes, assessments, levies, duties and other
                governmental charges, including the federal highway use tax,
                tolls, or other charges (collectively “Assessments”) assessed
                against the Vehicle arising from YOUR use, maintenance,
                inspection, possession, operation, repair and/or storage of the
                Vehicle.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Responsibility for Payment
              <span className="p">
                . YOU shall pay, as soon as the same come due and payable, all
                such Assessments and any other charges against or pertaining to
                the Vehicle, regardless of the name(s) to which they are levied or
                charged. You have provided authorization for deduction of any such
                payment pursuant to Section 4(e) above.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Notice.
              <span className="p">
                YOU shall promptly notify US when YOU receive any tax notices, tax
                reports or other inquiries or notices from taxing or governmental
                authorities. This Section is not intended to refer to and is not
                applicable to any income tax payable by either party.
              </span>
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={9}>
        <h4
          style={{
            paddingTop: "3pt",
            paddingLeft: "23pt",
            textIndent: "-17pt",
            textAlign: "left"
          }}
        >
          <u>
            Changes, Alterations, Improvements; Return of Vehicle at end of Term
          </u>
          .
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l13">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Modifications to Vehicle.
              <span className="p">
                YOU may not add, change, or remove any items, which are or will be
                affixed to the Vehicle, such as any equipment speed controls,
                unless either (i) WE give YOU advance written permission or (ii)
                there are any changes in any laws, rules, regulations or
                ordinances requiring specific additional equipment, devices, or
                modification of the Vehicle, with which change YOU will comply at
                YOUR sole cost and expense. Any item YOU affixed to the Vehicle
                upon return may be removed only if removal will not damage the
                Vehicle. Without limiting the foregoing, YOU agree that accident
                prevention and safety equipment may not be removed from the
                Vehicle or disabled.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              In the event that equipment or technology is later developed that i)
              is required for compliance with any statute, regulation, or
              ordinance; or ii) in Lessor’s reasonable discretion, may protect the
              Vehicle from loss or damage, You shall modify the Vehicle by
              application or installation of any such equipment or technology. The
              prohibition against removing or disabling accident prevention and
              safety equipment shall apply to any such later installed equipment
              or technology.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Return of Vehicle.
              <span className="p">
                At the expiration or termination of this Agreement, unless YOU
                exercise YOUR right under Section 5 to purchase the Vehicle, the
                Vehicle shall be returned to US at “Trade Terms,” which shall mean
                both
              </span>
            </p>
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              (i) unencumbered in any way, and (ii) in the same operating
              condition, order, repair and appearance as when received by YOU,
              reasonable wear and tear excepted. YOU agree to return the Vehicle
              promptly to a place reasonably designated by US.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Return Costs/Fees
              <span className="p">
                . Pursuant to Section 4 above, YOU have provided authorization for
                deduction of any of the following payments that may be charged at
                the time of return of the Vehicle, which amounts are in addition
                to any accrued and outstanding Base Payments, Mileage Payments,
                Additional Payments, or Deferred Payments:
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l14">
              <li data-list-text="(i)">
                <p
                  className="s7"
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  Repair to Trade Terms.
                  <span className="p">
                    To the extent the Vehicle is returned at less than Trade
                    Terms, YOU recognize the Lessor is required to bring the
                    Vehicle to Trade Terms, and that YOU are responsible for the
                    costs and fees to do so.
                  </span>
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(ii)">
                <p
                  className="s7"
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  Recovery Fee.
                  <span className="p">
                    If said Vehicle is not returned timely to the place so
                    designated by US, YOU will be charged a mileage recovery fee
                    not to exceed five dollars ($5.00) per mile the Vehicle must
                    travel to the designated place of return.
                  </span>
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(iii)">
                <p
                  className="s7"
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  Liquidated Damages.
                  <span className="p">
                    To the extent that you fail to return the Vehicle at Trade
                    Terms, you shall further be liable to US for the period of
                    time reasonably necessary for US to make the repairs to bring
                    the Vehicle to Trade Terms, which amount shall be equal to
                    Base Payments or any portion thereof accruing during such
                    time. You further acknowledge and agree such measure of
                    damages from such delay is standard within the industry and
                    represents a reasonable measure of such damage at the time of
                    execution of this Agreement and does not serve as a penalty.
                  </span>
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li data-list-text={10}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Inspection; Audit</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l15">
          <li data-list-text="(a)">
            <p
              style={{
                paddingLeft: "37pt",
                textIndent: "35pt",
                textAlign: "justify"
              }}
            >
              WE or our authorized agent have the right to inspect the Vehicle
              from time to time and at a reasonable time or place and YOU agree to
              return the Vehicle to 7135 Centennial Place, Nashville, Tennessee
              37209, or another point WE reasonably designate for OUR inspection.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "37pt",
                textIndent: "35pt",
                textAlign: "justify"
              }}
            >
              YOU grant US an express right to request, receive and inspect YOUR
              records, documentation, and any other available information at a
              location determined within OUR discretion in order to verify
              compliance under this Agreement, fitness for operation of the
              Vehicle, or for any other reasonable purpose WE may determine in OUR
              discretion
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={11}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Waivers of Warranties</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l16">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Waiver.
              <span className="p">
                WE are not the manufacturer, supplier or dealer of the Vehicle.
                THE CONDITION AND OPERATION OF THE VEHICLE YOU LEASE IS NOT
                WARRANTED OR GUARANTEED BY US FOR ANY PURPOSE, PARTICULAR OR
                OTHERWISE, AND IS LEASED ON AN “AS, IS WHERE IS” BASIS AND YOU
                ACCEPT THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THE
                VEHICLE. WE MAKE NO EXPRESS OR IMPLIED WARRANTIES RELATING TO THE
                VEHICLE, INCLUDING THOSE OF MERCHANTABILITY OR FITNESS FOR A
                PARTICULAR PURPOSE. WE SHALL HAVE NO LIABILITY TO YOU FOR ANY
                CLAIM, ACTION, LOSS OR
              </span>
            </p>
            <p
              style={{
                paddingTop: "3pt",
                paddingLeft: "24pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              DAMAGE, CAUSED OR ALLEGED TO BE CAUSED, DIRECTLY OR INDIRECTLY, BY
              THE VEHICLE OR BY ANY
            </p>
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              DEFECT OR DEFICIENCY IN THE VEHICLE. To the fullest extent of the
              law, each and every warranty (including without limitation the
              foregoing), is hereby waived.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Manufacturer Responsibility; Operation of Vehicle.
              <span className="p">
                We shall have no liability for any damages, whether direct,
                indirect, general, special, incidental, exemplary, punitive or
                consequential, incurred by YOU as a result of any defect or
                malfunction in the Vehicle and YOU shall look solely to the
                manufacturer, supplier or dealer of the Vehicle, and not to US,
                for any and all claims related to the Vehicle. If a standard
                warranty of the Vehicle’s manufacturer is applicable to the
                Vehicle, WE will advise YOU, and to the extent WE may do so, WE
                shall assign the warranty to YOU or otherwise give YOU the benefit
                WE receive from the warranty. YOU agree to use the Vehicle only in
                a manner and for the use contemplated by the manufacturer thereof,
                and shall operate the Vehicle so as to preserve all applicable
                manufacturer’s warranties. The foregoing applicable manufacturer’s
                warranty, if any, is the sole warranty intended to survive this
                Section 11.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={12}>
        <h4
          style={{ paddingLeft: "24pt", textIndent: "-18pt", textAlign: "left" }}
        >
          <u>Insurance Coverage</u>.
          <span className="p">
            YOU are responsible for providing and maintaining insurance coverage
            for the Vehicle in accordance with the following requirements:
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l17">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Types of Insurance.
              <span className="p">
                YOU shall obtain and maintain, independently or through US, as YOU
                so choose, and at YOUR own expense, insurance for the following
                coverages in the following amounts, which amounts may be subject
                to adjustment by US in our discretion (and if so adjusted, shall
                be put into effect on the next succeeding renewal date of such
                insurance):
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l18">
              <li data-list-text="(i)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  “all risk” insurance against loss, theft or damage to the
                  Vehicle at the full insurable value of the Vehicle, including
                  without limitation “GAP” insurance of not less than $20,000 in
                  excess of the value of the Vehicle,
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(ii)">
                <p
                  style={{
                    paddingLeft: "47pt",
                    textIndent: "-17pt",
                    textAlign: "left"
                  }}
                >
                  commercial automobile liability insurance in an amount not less
                  than $1,000,000,
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(iii)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  commercial general liability insurance (including contractual
                  liability, products liability, and completed operations
                  coverages) reasonably satisfactory to US,
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(iv)">
                <p
                  style={{
                    paddingLeft: "47pt",
                    textIndent: "-17pt",
                    textAlign: "left"
                  }}
                >
                  non-trucking liability insurance in an amount not less than
                  $1,000,000, and
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(v)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  such other insurance against such other risks of loss and with
                  such terms, as shall in each case be reasonably required by US
                  (as to insurance carriers, amounts, and otherwise).
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Insurance Carriers.
              <span className="p">
                Any insurance carrier selected and utilized by YOU must be rated
                at least “A” by AM Best rating company, financially sound and
                licensed to do business in the applicable state.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Policy Conditions.
              <span className="p">
                Each policy shall: (i) name US as sole loss payee with respect to
                the Vehicle; (ii) name US as an additional insured and provide
                that such insurance shall have cross-liability and severability of
                interest endorsements (which shall not increase the aggregate
                policy limits of YOUR insurance); (iii) provide for each insurer’s
                waiver of its right of subrogation against US and YOU; (iv)
                provide that such insurance shall not be invalidated by any action
                of, or breach of warranty by YOU of a provision of any of its
                insurance policies, and shall waive all defenses, including
                set-off, counterclaim, or offset, against US; (v) provide that
                YOUR insurance shall be primary without a right of contribution of
                or from OUR insurance, if any, or any obligation on the part of US
                to pay YOUR premiums; (vi) shall contain a clause requiring the
                insurer to give US at least thirty (30) days prior written notice
                of its cancellation (other than cancellation for non-payment for
                which ten (10) days’ notice shall be sufficient), and (vii)
                contain such deductibles and retentions that are reasonably
                acceptable to US.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Certificates.
              <span className="p">
                YOU shall on or prior to the date of execution of this Agreement,
                and at least annually, but in each case, prior to each policy
                renewal, furnish to US certificates of insurance or other evidence
                satisfactory to US that such insurance coverage is in effect. You
                shall name US as a certificate holder on each policy.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(e)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Notice of Potential Claims.
              <span className="p">
                YOU further agree to give US prompt notice of any damage to, theft
                of, or loss of, the Vehicle, or any part thereof and/or of any
                other matter or claim for which insurance coverage may be
                applicable. YOU shall cooperate fully with US and any applicable
                insurance carriers in documenting any such incident, in any
                investigation of such incident and with respect to any legal
                action, regulatory hearing or other proceeding arising from
              </span>
            </p>
            <p
              style={{
                paddingTop: "3pt",
                paddingLeft: "24pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              the operation of the Vehicle, the relationship created by this
              Agreement. YOU shall, upon OUR reasonable request and at YOUR
              expense, provide reasonable assistance in such legal action or other
              proceeding, attend depositions, hearings and trials, and assist in
              securing evidence or obtaining the attendance of witnesses. You
              acknowledge that failure to provide such notice or cooperation could
              cause substantial harm to LESSOR.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(f)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Attorney-in-Fact/Proceeds.
              <span className="p">
                In the event that a claim for loss or damage under any insurance
                policy results in insurance proceeds paid to YOU to repair or
                replace the Vehicle or to procure replacement equipment during any
                period of Downtime, YOU hereby assign such proceeds to US and
                appoint US as attorney-in-fact to collect such proceeds and apply
                same to any outstanding obligations under any Lease Document(s).
                WE shall remit to YOU the balance of any proceeds in excess of any
                outstanding obligations under any Lease Document(s).
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(g)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Casualty Event
              <span className="p">
                . In the event that a claim under any insurance policy results in
                a total loss of the Vehicle, YOU hereby waive any salvage rights
                to the Vehicle, and hereby assign such rights to US.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(h)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Failure to Obtain Insurance.
              <span className="p">
                Notwithstanding failure to maintain insurance being a breach of
                this Agreement, YOU shall be solely liable for any losses to US
                which may occur because no insurance has been obtained or the
                coverage of the insurance which has been obtained is incomplete or
                insufficient. The parties agree that all applicable insurance
                coverages indicated in this Section shall be available, and may be
                used by US, to satisfy YOUR indemnification obligations under
                Section 16 below.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={13}>
        <p
          className="s6"
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          Equipment Security Escrow; Authorizations for Deduction and Application.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l19">
          <li data-list-text="a)">
            <p
              className="s7"
              style={{
                paddingLeft: "28pt",
                textIndent: "13pt",
                textAlign: "justify"
              }}
            >
              Establishment of Escrow Fund
              <span className="p">
                . LESSOR shall establish and YOU shall fund an “Equipment Security
                Escrow” for the purpose of securing YOUR obligations under this
                Lease Agreement, including, but not limited to, all payments as
                provided in Section 4, all repairs and maintenance of the
                Equipment as provided in Section 7, any and all costs incurred by
                Lessor to satisfy the requirements under Section 9, and all
                insurance obligations as provided in Section 12, and all other
                amounts that may become due under this Agreement (including
                without limitation indemnity obligations as provided in Section 16
                below). Interest on the amount held in escrow shall be calculated
                and paid to YOU on a quarterly basis. The interest rate shall be
                established on the date the interest period begins and shall be at
                least equal to the average yield or equivalent coupon issue yields
                on 91-day, 13-week Treasury bills as established in the weekly
                auction by the U.S. Department of Treasury. For purposes of
                calculating the balance of the escrow fund on which interest must
                be paid, Lessor may deduct a sum equal to the average advance made
                to the YOU during the period of time for which the interest is
                paid. To the extent the account balance is not at the required
                minimum, then interest will be paid to the escrow account. In
                addition, to the extent there are Additional Payments outstanding
                and no deferment has been approved pursuant to Section 4(d) above
                (or in the case of such an approved deferment, YOU are in default
                thereof), YOU authorize US to deduct additional amounts from any
                present or future settlement (in part or in full) in order to
                cover such Additional Payments (in part or in full) due hereunder.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="b)">
            <p
              className="s7"
              style={{
                paddingLeft: "28pt",
                textIndent: "13pt",
                textAlign: "justify"
              }}
            >
              Authorization for Settlement Deductions<span className="p">.</span>
              <b>
                YOU AGREE AND HEREBY DO AUTHORIZE AND DIRECT CARRIER TO MAKE
                DEDUCTIONS FROM CONTRACT SETTLEMENTS OR ANY ESCROWED FUNDS IN
                ORDER TO ESTABLISH AND MAINTAIN THE EQUIPMENT SECURITY ESCROW AS
                PROVIDED IN THIS SECTION 13.
              </b>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="c)">
            <p
              className="s7"
              style={{
                paddingLeft: "28pt",
                textIndent: "13pt",
                textAlign: "justify"
              }}
            >
              Application of Escrowed Funds.
              <span className="p">
                Notwithstanding YOUR obligations under this Lease Agreement to
                make payments and repair, maintain, and insure the Equipment, in
                the event that YOU fail or are unable to fulfill such obligations,
              </span>
              <b>
                YOU AGREE AND HEREBY DO AUTHORIZE AND DIRECT LESSOR TO APPLY ANY
                AND ALL AMOUNTS HELD IN THE EQUIPMENT SECURITY ESCROW FUND TO ANY
                OUTSTANDING OBLIGATIONS UNDER THIS LEASE AGREEMENT, IN LESSOR’S
                DISCRETION.
              </b>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="d)">
            <p
              style={{
                paddingLeft: "28pt",
                textIndent: "13pt",
                textAlign: "justify"
              }}
            >
              <i>Location, Amount of Escrowed Funds. </i>The location and amount
              of the Equipment Security Escrow depends on whether or not you are
              currently hauling under a Contractor Hauling Agreement (a
              “Contractor Hauling Agreement”) with Western Express, Inc. (“WEI”)
              The Equipment Security Escrow Amount shall be equal to $
              <u>&nbsp;25,000 &nbsp;&nbsp; </u>.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l20">
              <li data-list-text="a.">
                <p
                  className="s7"
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  Combined Escrow.
                  <span className="p">
                    To the extent YOU have executed a Hauling Agreement with WEI,
                    the Equipment Security Escrow shall be consolidated into, and
                    shall be contained as an undivided portion within, any escrow
                    account established under such Hauling Agreement (together,
                    the “Combined Escrow”). For the avoidance of doubt, the
                    Combined Escrow shall provide security both for the Hauling
                    Agreement and this Agreement, For purposes of this Agreement,
                    LESSOR grants WEI the authority to hold the undivided portion
                    of the Combined Escrow that constitutes the Equipment Security
                    Escrow and
                  </span>
                </p>
                <p
                  style={{
                    paddingTop: "3pt",
                    paddingLeft: "48pt",
                    textIndent: "0pt",
                    textAlign: "justify"
                  }}
                >
                  instructs WEI to apply such escrowed funds in accordance with
                  this Agreement. As consideration for execution of such Hauling
                  Agreement, and recognition that execution of such Hauling
                  Agreement provides LESSOR with some comfort that revenues could
                  be available for YOU to satisfy YOUR obligations hereunder, the
                  undivided portion of the Combined Escrow that constitutes the
                  Equipment Security Escrow is not required to be fully funded at
                  inception, and instead may be funded over time.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="b.">
                <p
                  className="s7"
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  Separate Escrow.
                  <span className="p">
                    To the extent that YOU have NOT executed a Contractor Hauling
                    Agreement or are hauling under authority other than that of
                    WEI, then the Equipment Security Escrow may no longer be
                    consolidated in the Combined Escrow, shall be established
                    separately hereunder, and shall be fully funded at the time of
                    execution of this Agreement or prior to YOUR hauling under
                    authority other than that of WEI. From time to time, WE may
                    request that the Equipment Security Escrow be replenished on
                    top of the amounts that may be accrued on a cents per mile
                    basis through the normal settlement
                  </span>
                </p>
              </li>
            </ol>
          </li>
        </ol>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={14}>
        <h4
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>Drivers; Compliance.</u>
          <span className="p">
            YOU shall permit only properly licensed and competent drivers to
            operate the Vehicle, as required by applicable law, rules, regulations
            and ordinances. YOU agree that the Vehicle shall at all times be used
            in compliance with any federal, state and municipal laws, rules,
            regulations or ordinances, and without determination of whether any
            violation or assessment constitutes a breach hereunder, YOU shall be
            solely responsible for the payment of any fines or other penalties
            arising out of such violation or assessment.
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={15}>
        <h4
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>Cooperation</u>.
          <span className="p">
            WE and YOU agree to keep each other reasonably informed of any major
            problems, attachments, liens, or encumbrances which arise in the
            operation of the Vehicle, including reporting any accident, lawsuit,
            or other legal action, cooperating between each other and insurers in
            the investigation, documentation, prosecution or defense of any
            accidents, claims, suits or legal actions arising from the operation
            of the Vehicle, and subject to YOUR indemnity obligations under
            Section 16 below.
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={16}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Indemnity</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l21">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Scope.
              <span className="p">
                YOU assume all risk and liability arising from the use,
                maintenance, inspection, possession, operation, repair and storage
                of the Vehicle leased under this Agreement and release US from any
                such risk and/or liability in that regard. YOU shall defend, hold
                harmless, indemnify and reimburse US (as well as OUR directors,
                officers, employees, agents, and representatives) from, for and
                against all asserted, threatened, or potential losses, expenses,
                liabilities, damages, claims, lawsuits, actions at law or equity,
                administrative or governmental actions or legal actions (including
                reasonable attorneys’ fees and costs), and including but not
                limited to claims and actions, by YOU, by any of YOUR employees,
                agents, servants, contractors, subcontractors or representatives,
                the Carrier (except to the extent of Carrier’s negligence or
                fault) or any third party, arising out of the use, maintenance,
                inspection, possession, operation, repair and/or storage of said
                Vehicle or performance of the Lease Documents (collectively,
                “Indemnified Claims”).
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Notice.
              <span className="p">
                In the event YOU become aware of or receive an asserted
                Indemnified Claim, YOU shall promptly notify US of such claim.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Survival.
              <span className="p">
                Notwithstanding anything to the contrary contained in any Lease
                Document, this Section 16 shall survive termination of this
                Agreement for any reason other than termination in compliance with
                Section 3(b) (including without limitation payment of all known
                amounts arising from such termination), in which case this Section
                16 shall survive termination of this Agreement for a period of
                three (3) years after consummation of such compliant termination.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Offset Right.
              <span className="p">
                To the extent YOU are owed any monies under the terms of any Lease
                Document, WE reserve the right to offset those amounts against any
                outstanding payments or obligations hereunder.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={17}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Title; Encumbrances</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l22">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Title.
              <span className="p">
                This Agreement constitutes a lease, with an option to purchase.
                YOU are not buying the Vehicle at the time you sign this
                Agreement, will not have any security or ownership interest in the
                Vehicle at that time, and thereafter and will only receive title
                to the Vehicle when YOU have fully performed YOUR obligations
                under this Agreement or have purchased the Vehicle pursuant to
                Section 5 above. Title to the Vehicle shall at all times remain in
                Lessor’s name, unless purchased by Lessee pursuant to Section 5,
                and
              </span>
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingTop: "3pt",
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Duty to Defend.
              <span className="p">
                Lessee shall at all times, at Lessee’s own cost and expense,
                protect and defend the Vehicle and Lessor’s title from and against
                all claims, liens, encumbrances, rights of others, judgments,
                seizures and legal processes (collectively “Encumbrances”).
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Ownership.
              <span className="p">
                WE, to the extent allowed by law, retain all benefits and burdens
                associated with OUR interest in and ownership of the Vehicle,
                including, but not limited to, all rights of depreciation for tax
                purposes. Upon Lessor’s request Lessee agrees to affix to the
                Vehicle in a conspicuous place such labels, signs or other devices
                as may be required to identify Lessor as the owner of the Vehicle.
                If this Agreement is deemed at any time to be one intended as
                security, YOU hereby grant US a security interest in the Vehicle
                and agree that the Vehicle shall secure any indebtedness owing by
                YOU to US. YOU agree to execute any financing statements or such
                other documents necessary to effect or evidence such a security
                interest.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={18}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Independent Business</u>.
        </h4>
        <ol id="l23">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingTop: "6pt",
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Lessor/Lessee Status.
              <span className="p">
                This Contract is intended by the parties to create the
                relationship of lessor/lessee between LESSOR and LESSEE and not
                the relationship of employer/employee, master/servant, partners or
                joint venture. Neither LESSEE, nor LESSEE’S employees, agents,
                servants, contractors, subcontractors and/or drivers (collectively
                “Workers”) are to be considered employees of LESSOR at any time,
                under any circumstance or for any purpose. It is agreed by the
                parties hereto that LESSEE assumes full and complete
                responsibility for all Workers utilized by LESSEE in the
                performance of all duties and obligations under this Agreement
              </span>
              .
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Requirements to Haul Under Additional or Alternate Carrier
              Authority.
              <span className="p">
                The parties agree that at the time YOU sign this Agreement, YOU
                have chosen to operate the Vehicle under a contract with the
                Carrier indicated on Schedule B, and may operate the Vehicle for
                another carrier or other entity, at any time and in YOUR sole
                discretion, subject to the requirements of this Section 18(b).
                Upon satisfaction of the following conditions, or advance written
                waiver from Lessor, YOU may request amendment of Schedule B to
                designate a different or additional motor carrier (a “New
                Carrier”) as follows:
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l24">
              <li data-list-text="(i)">
                <p
                  className="s7"
                  style={{
                    paddingLeft: "47pt",
                    textIndent: "-17pt",
                    textAlign: "left"
                  }}
                >
                  Lessee Requirements<span className="p">.</span>
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
                <ol id="l25">
                  <li data-list-text="(1)">
                    <p
                      className="s7"
                      style={{
                        paddingLeft: "50pt",
                        textIndent: "-18pt",
                        textAlign: "justify"
                      }}
                    >
                      No default.
                      <span className="p">
                        YOU are current on all your obligations under the Lease
                        Documents and any hauling agreement (including without
                        limitation a Contractor Hauling Agreement);
                      </span>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="(2)">
                    <p
                      className="s7"
                      style={{
                        paddingLeft: "50pt",
                        textIndent: "-18pt",
                        textAlign: "justify"
                      }}
                    >
                      Catch up of deferred Base Payments
                      <span className="p">
                        . You have paid any and all Deferred Payments that were
                        deferred prior to the satisfaction of these conditions or
                        advance written waiver from Lessor;
                      </span>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="(3)">
                    <p
                      className="s7"
                      style={{
                        paddingLeft: "50pt",
                        textIndent: "-18pt",
                        textAlign: "justify"
                      }}
                    >
                      Escrow.
                      <span className="p">
                        YOU must fund the Equipment Security Escrow in an amount
                        not less than $25,000, which balance shall be maintained
                        at all times. The Lease Escrow will be held for the Term
                        by Lessor as security for the obligations hereunder,
                        including without limitation Base Payments, Mileage
                        Payments, Additional Payments, Deferred Payments
                        (including without limitation indemnification obligations
                        pursuant to Section 16 hereof). YOU AGREE AND HEREBY DO
                        AUTHORIZE AND DIRECT LESSOR TO MAKE DEDUCTIONS FROM THE
                        EQUIPMENT SECURITY ESCROW IN
                      </span>
                    </p>
                    <p
                      style={{
                        paddingLeft: "50pt",
                        textIndent: "0pt",
                        textAlign: "justify"
                      }}
                    >
                      ORDER TO PAY YOUR OBLIGATIONS HEREUNDER; provided, nothing
                      hereunder shall be deemed to limit the scope of authority
                      granted in Section 4 above; and
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="(4)">
                    <p
                      className="s7"
                      style={{
                        paddingLeft: "50pt",
                        textIndent: "-18pt",
                        textAlign: "justify"
                      }}
                    >
                      Representations &amp; Warranties.
                      <span className="p">
                        Your request for amendment of Schedule B shall act as a
                        restatement and ratification of the representations and
                        warranties contained herein as of the date of such
                        request, and you acknowledged that such representations
                        and warranties are a material inducement to LESSOR’s
                        approval of such request.
                      </span>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                </ol>
              </li>
              <li data-list-text="(ii)">
                <p
                  className="s7"
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  New Carrier Requirements.
                  <span className="p">
                    Any New Carrier with whom YOU chose to do business during the
                    Term must satisfy the following criteria for the protection of
                    OUR interest in and ownership of the Vehicle:
                  </span>
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
                <ol id="l26">
                  <li data-list-text="(1)">
                    <p
                      className="s7"
                      style={{
                        paddingLeft: "50pt",
                        textIndent: "-18pt",
                        textAlign: "justify"
                      }}
                    >
                      Safety Rating.
                      <span className="p">
                        The New Carrier must have and maintain a “satisfactory”
                        rating with the U.S. Department of Transportation;
                      </span>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="(2)">
                    <p
                      className="s7"
                      style={{
                        paddingLeft: "50pt",
                        textIndent: "-18pt",
                        textAlign: "justify"
                      }}
                    >
                      Insurance.
                      <span className="p">
                        The New Carrier must maintain the insurance policies in
                        accordance with Section 12 hereof;
                      </span>
                    </p>
                  </li>
                  <li data-list-text="(3)">
                    <p
                      className="s7"
                      style={{
                        paddingTop: "3pt",
                        paddingLeft: "50pt",
                        textIndent: "-18pt",
                        textAlign: "justify"
                      }}
                    >
                      Payments.
                      <span className="p">
                        The New Carrier must agree in writing to remit directly to
                        US amounts equal to the Base Payments, Mileage Payments,
                        and Additional Payments due to US under this Agreement, on
                        an ongoing basis and as they become due hereunder, which
                        carrier may deduct from YOUR compensation settlements, any
                        escrow funds and/or any other amounts due YOU under YOUR
                        contract with the Carrier, which contract shall be in a
                        form reasonably acceptable to US depending on the facts
                        and circumstances known to US. YOU agree to provide US
                        with a copy of the written contract or document between
                        YOU and the New Carrier which shall contain and reflect
                        the foregoing agreement, to which WE will be a third-party
                        beneficiary for purposes of the payments due hereunder;
                        and
                      </span>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="(4)">
                    <p
                      className="s7"
                      style={{
                        paddingLeft: "50pt",
                        textIndent: "-18pt",
                        textAlign: "justify"
                      }}
                    >
                      Credit Check.
                      <span className="p">
                        The New Carrier must authorize Lessor to perform a check
                        of carrier's creditworthiness through commercially
                        reasonable means, including, but not limited to, obtaining
                        a Dunn &amp; Bradstreet Report, checking bank and trade
                        references, etc., provide Lessor with information
                        reasonably necessary for Lessor to perform such
                        creditworthiness assessment, and have and maintain credit
                        worthiness satisfactory, in Lessor’s reasonable
                        discretion, to mitigate Lessor’s increased risk(s).
                      </span>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li data-list-text={19}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Event of Default</u>.
          <span className="p">
            The following events shall constitute “Events of Default”:
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l27">
          <li data-list-text="(i)">
            <p
              className="s7"
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                lineHeight: "13pt",
                textAlign: "left"
              }}
            >
              Immediate Events of Default.
              <span className="p">
                An occurrence of the following events is immediately considered
                Events of
              </span>
            </p>
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              Default:
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l28">
              <li data-list-text="(1)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "left"
                  }}
                >
                  Failure to timely pay all or any portion of the amounts payable
                  to US under any Lease Document when due and payable;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(2)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "left"
                  }}
                >
                  YOU remove, sell, transfer, assign, encumber, or otherwise
                  dispose or part with possession of the Vehicle or any portion
                  thereof, or attempt to do any of the foregoing, without OUR
                  written consent;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(3)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "left"
                  }}
                >
                  Seizure of or levy upon the Vehicle by reason of any legal or
                  governmental process directed against YOU;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(4)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  YOUR failing generally to pay YOUR debts or financial
                  obligations as they become due, or a petition in bankruptcy,
                  insolvency or reorganization is filed by or against YOU, or YOU
                  make an assignment for the benefit of creditors or YOU consent
                  to or acquiesce in the appointment of a receiver, liquidator or
                  trustee of YOU or YOUR business or of the whole or any part of
                  YOUR assets;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(5)">
                <p
                  style={{
                    paddingLeft: "47pt",
                    textIndent: "-17pt",
                    textAlign: "left"
                  }}
                >
                  YOUR taking unlawful possession of the Vehicle or intentionally
                  causing damage to the Vehicle;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(6)">
                <p
                  style={{
                    paddingLeft: "47pt",
                    textIndent: "-17pt",
                    textAlign: "left"
                  }}
                >
                  YOUR material violation of any applicable laws, rules,
                  regulations and/or ordinances;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(7)">
                <p
                  style={{
                    paddingLeft: "47pt",
                    textIndent: "-17pt",
                    textAlign: "left"
                  }}
                >
                  Use of the Vehicle for anything other than the Purpose of this
                  Agreement;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(8)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  Termination of, or any default that with either notice or the
                  passage of time could give rise to a termination of any
                  applicable hauling agreement (including without limitation a
                  Contractor Hauling Agreement); and
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(9)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  OUR determination in OUR reasonable discretion that YOU or
                  anyone operating the Vehicle hereunder is unfit to operate such
                  Vehicle or YOU are otherwise unable to perform hereunder; and
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(10)">
                <p
                  style={{
                    paddingLeft: "47pt",
                    textIndent: "-17pt",
                    textAlign: "left"
                  }}
                >
                  YOUR death.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="(ii)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Events of Default with Cure Periods.
              <span className="p">
                The occurrence of the following events, followed by YOUR failure
                to cure such occurrence within ten (10) days of such occurrence,
                shall constitute an Event of Default, whether or not Lessor
                provides notice of the occurrence or failure to cure, which notice
                is expressly waived by YOU, provided, however, that if such
                default or breach is not curable, such event shall be an immediate
                Event of Default:
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l29">
              <li data-list-text="(1)">
                <p
                  style={{
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  Failure to perform or observe any covenant, agreement or
                  obligation under any Lease Document other than those enumerated
                  in Section 19(i);
                </p>
              </li>
              <li data-list-text="(2)">
                <p
                  style={{
                    paddingTop: "3pt",
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  YOUR breaching of any representation or warranty by YOU to US
                  under this Agreement, or furnishing any documents or information
                  in connection therewith, which prove to be incorrect in any
                  material respect at the time made; and
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(3)">
                <p
                  style={{
                    paddingLeft: "47pt",
                    textIndent: "-17pt",
                    textAlign: "left"
                  }}
                >
                  YOUR non-material violation of any applicable laws, rules,
                  regulations and/or ordinances.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="(iii)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Notice Requirement
              <span className="p">
                . YOU shall provide US immediate notice of (i) any Event of
                Default that is known or should have reasonably been known, or
                (ii) any occurrence that is known or reasonably should have been
                known, and that with which the passage of time or notice would
                become an Event of Default.
              </span>
            </p>
          </li>
        </ol>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={20}>
        <h4
          style={{ paddingLeft: "41pt", textIndent: "-35pt", textAlign: "left" }}
        >
          <u>Remedies and Damages</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l30">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "37pt",
                textIndent: "35pt",
                textAlign: "justify"
              }}
            >
              Cumulative Remedies.
              <span className="p">
                Upon the occurrence of an Event of Default, WE may exercise any
                one or more of the following remedies in any combination or
                sequence not expressly prohibited by law:
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l31">
              <li data-list-text="(i)">
                <p
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "36pt",
                    textAlign: "justify"
                  }}
                >
                  require YOU to cause the return of the Vehicle to US, at YOUR
                  sole cost and expense, to a place and within a time period
                  reasonably designated by US;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(ii)">
                <p
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "36pt",
                    textAlign: "justify"
                  }}
                >
                  take physical possession of and remove the Vehicle from whatever
                  location it is found with or without prior demand or notice to
                  YOU, with or without legal process or proceedings of any kind
                  and at YOUR sole cost and expense, it being understood that the
                  ability and right of repossession upon default is a basis for
                  and in consideration of the terms and provisions of this
                  Agreement. In such event, YOU waive and release us from any and
                  all damages occasioned by such retaking except to the extent of
                  OUR gross negligence or willful misconduct, and YOU specifically
                  agree that WE may, at OUR discretion, use, ship, store, repair
                  or lease the Vehicle and sell or otherwise dispose of the
                  Vehicle by private or public sale, with or without notice to
                  YOU;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(iii)">
                <p
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "36pt",
                    textAlign: "justify"
                  }}
                >
                  demand from, and/or bring an action against, YOU for all Base
                  Payments, Mileage Payments, and Additional Payments (including
                  without limitation those costs, fees and charges set forth in
                  Sections 2(d), 4, 9(c), 13, 16, and 32, hereof, or pursuant to
                  any other Lease Document, that have accrued before, or arise
                  from, any Event of Default);
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(iv)">
                <p
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "36pt",
                    textAlign: "justify"
                  }}
                >
                  without notice to YOU, terminate the Agreement, but such
                  termination shall not release YOU from the remedies, damages,
                  liabilities and obligations arising from any Event of Default;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(v)">
                <p
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "36pt",
                    textAlign: "justify"
                  }}
                >
                  recovery of all expenses, fees and costs of any kind incurred by
                  US in connection with the enforcement of OUR remedies, including
                  reasonable attorneys’ fees;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(vi)">
                <p
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "36pt",
                    textAlign: "justify"
                  }}
                >
                  to the extent that WE seek appointment of a receiver or other
                  injunctive relief, you acknowledge and agree that money damages
                  would be difficult to calculate and YOU do not object to the
                  appointment of such receiver or such injunctive relief; and
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(vii)">
                <p
                  style={{
                    paddingLeft: "36pt",
                    textIndent: "36pt",
                    textAlign: "justify"
                  }}
                >
                  except as expressly limited herein, WE may take any other or
                  further available remedy hereunder, at law, or in equity.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "37pt",
                textIndent: "35pt",
                textAlign: "justify"
              }}
            >
              Waiver of Certain Rights by Lessee.
              <span className="p">
                YOU hereby expressly waive any right YOU may have to possession of
                the Vehicle after an Event of Default and all claims YOU may have
                for damages or injuries related to repossession, sale or other
                disposition of the Vehicle hereunder.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              className="s7"
              style={{
                paddingLeft: "37pt",
                textIndent: "35pt",
                textAlign: "justify"
              }}
            >
              Authorization
              <span className="p">
                . You have provided authorization for deduction of any obligations
                hereunder pursuant to Sections 4 and 13 (if applicable) above.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              className="s7"
              style={{
                paddingLeft: "37pt",
                textIndent: "35pt",
                textAlign: "justify"
              }}
            >
              Reasonableness of Damage Measures.
              <span className="p">
                YOU acknowledge the difficulty of establishing a value for damages
                related to an Event of Default, and by reason of such difficulty,
                agree that these remedies represent an agreed and reasonable
                measure of damages to US and do not constitute a forfeiture or
                penalty.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(e)">
            <p
              className="s7"
              style={{
                paddingLeft: "37pt",
                textIndent: "35pt",
                textAlign: "justify"
              }}
            >
              Cumulative Nature of Remedies<span className="p">; </span>No Waiver.
              <span className="p">
                All remedies hereunder are cumulative and are in addition to any
                other remedies provided for by law or equity, and may, to the
                extent permitted by law, be exercised
              </span>
            </p>
            <p
              style={{
                paddingTop: "3pt",
                paddingLeft: "37pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              concurrently or separately. The exercise of any one remedy shall not
              be deemed to be an election of such remedy or to preclude the
              exercise of any other remedy. No failure on the part of US to
              exercise and no delay in exercising any right or remedy shall
              operate as a waiver thereof or modify the terms of this Agreement.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(f)">
            <p
              className="s7"
              style={{
                paddingLeft: "37pt",
                textIndent: "35pt",
                textAlign: "justify"
              }}
            >
              Savings Clause
              <span className="p">
                . Notwithstanding any provision in this Agreement or any other
                Lease Documents, the total liability for payments of interest and
                payments in the nature of interest, including, without limitation,
                all charges, fees, or other sums which may at any time be deemed
                to be interest, shall not exceed the limit imposed by the usury
                laws of the jurisdiction governing this Agreement or any other
                applicable law. In the event the total liability of payments of
                interest and payments in the nature of interest, including,
                without limitation, all charges, fees, exactions or other sums
                which may at any time be deemed to be interest, shall, for any
                reason whatsoever, result in an effective rate of interest, which
                for any month or other interest payment period exceeds the limit
                imposed by the usury laws of the jurisdiction governing this
                Agreement, all sums in excess of those lawfully collectible as
                interest for the period in question shall, without further
                agreement or notice by, between, or to any party hereto, be
                applied to the reduction of any obligations under this Agreement
                immediately upon receipt of such sums by the US, with the same
                force and effect as though the YOU had specifically designated
                such excess sums to be so applied to the reduction of any such
                obligations and WE had agreed to accept such sums as a
                penalty-free payment; provided, however, that the WE may, at any
                time and from time to time, elect, by notice in writing to the
                YOU, to waive, reduce, or limit the collection of any sums in
                excess of those lawfully collectible as interest rather than
                accept such sums as a prepayment of the outstanding obligations.
                It is the intention of the parties that YOU do not intend or
                expect to pay nor do WE intend or expect to charge or collect any
                interest under this Agreement greater than the highest non-
                usurious rate of interest which may be charged under applicable
                law.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={21}>
        <h4
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>Personal Property</u>.
          <span className="p">
            WE assume no liability for loss or damage to personal property in the
            Vehicle, regardless of ownership. If any personal property is in the
            Vehicle at the time WE secure possession of the Vehicle under this
            Agreement, WE shall not be liable for any damage to, loss of, theft of
            or disposition of such property.
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={22}>
        <h4
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>Casualty</u>.
          <span className="p">
            In the event for any reason the Vehicle becomes lost, stolen,
            destroyed or otherwise completely unusable (herein, each, a “Complete
            Loss”), on the date of the scheduled Base Payment next succeeding the
            occurrence of such Complete Loss, YOU shall pay to US the sum of (a)
            the fair market value of the Vehicle at the time of the Complete Loss,
            and (b) all Base Payments, Mileage Payments, and Additional Payments
            which have accrued under this Agreement through the date of the
            Complete Loss or arising from the Complete Loss. Upon payment of all
            such sums, this Agreement shall terminate.
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={23}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>Assignment by Lessor, Subordination</u>.
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l32">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Assignment by Lessor.
              <span className="p">
                WE may assign, in full or in part, at any time, to any person,
                business or entity, without YOUR approval and without notice to
                YOU: (i) the Vehicle, (ii) this Agreement; (iii) OUR rights and
                privileges hereunder; and (iv) all or any part of the monies due
                to US or to become due to US hereunder, and YOU hereby consent and
                agree to any such assignment. All rights and privileges (including
                without limitation any indemnification rights pursuant to Section
                16) shall be assigned, and are expressly made for the benefit of,
                and shall be enforceable by, US or OUR successors and assigns.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Subordination of Lessee’s Rights
              <span className="p">
                . YOU acknowledge and agree that all of YOUR rights under this
                Agreement in and to the Vehicle, including YOUR right to
                possession of the Vehicle, are subordinate, junior, and subject to
                the rights and claims of any assignee against the Vehicle under
                any instrument, lease, mortgage or title retention or other
                security agreement, whether now existing or hereafter created,
                including but not limited to the right of any assignee to take
                possession of the Vehicle.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Waiver of YOUR Offset or Recoupment Rights.
              <span className="p">
                YOU promise and agree to settle all claims against US directly
                with US and hereby waive, release, relinquish and disclaim as to
                any assignee all counterclaims, rights of set- off or recoupment,
                and defenses YOU may have against US, including any right to
                freeze, withhold payment of, or to refrain from paying, any monies
                that are due or to become due under the terms of this Agreement,
                except that YOU shall not be liable to any assignee for monies
                paid to US in accordance with the terms of this Agreement prior to
                the time such assignee notifies YOU to pay such assignee directly.
                After such notice from the assignee, YOU agree to pay directly to
                such assignee all monies owing under the Agreement.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={24}>
        <h4
          style={{ paddingLeft: "24pt", textIndent: "-18pt", textAlign: "left" }}
        >
          <u>No Assignment By Lessee</u>.
          <span className="p">
            YOU shall not have the right to assign, sublease or encumber the
            Vehicle in any way, nor to sell or assign this Agreement without OUR
            prior written consent, and any attempt to do so will be null and void.
          </span>
        </h4>
        <p
          style={{
            paddingTop: "3pt",
            paddingLeft: "24pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          WE may assign or transfer this Agreement and/or OUR interest in the
          Vehicle to any person, business or entity at any time without prior
          notice to YOU.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={25}>
        <h4
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>Consequential Damages</u>.
          <span className="p">
            Notwithstanding anything to the contrary herein, YOU expressly waive
            and WE shall not be liable for any incidental, indirect,
            consequential, exemplary, special, or punitive damages under any
            circumstances whatsoever, including, without limitation, any failure
            of US to comply with the provisions of this Agreement, regardless of
            whether such damages are foreseeable or notice of them is given.
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={26}>
        <h4
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>YOUR Waivers</u>.
          <span className="p">
            In addition to any other waivers that may be contained herein, YOU
            hereby waive any and all rights and remedies, including but not
            limited to YOUR right to:
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l33">
          <li data-list-text="(a)">
            <p
              style={{
                paddingLeft: "59pt",
                textIndent: "-17pt",
                textAlign: "left"
              }}
            >
              Reject the Vehicle;
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "59pt",
                textIndent: "-17pt",
                textAlign: "left"
              }}
            >
              Revoke acceptance of the Vehicle;
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              style={{
                paddingLeft: "59pt",
                textIndent: "-17pt",
                textAlign: "left"
              }}
            >
              Recover damages from US for any breaches of warranty;
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              style={{
                paddingLeft: "59pt",
                textIndent: "-17pt",
                textAlign: "left"
              }}
            >
              Claim a security interest in the Vehicle for any reason;
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(e)">
            <p
              style={{
                paddingLeft: "60pt",
                textIndent: "-18pt",
                textAlign: "justify"
              }}
            >
              Deduct, offset or recoup any claimed damages resulting from OUR
              breach or default, if any, under this Agreement, from any monies,
              lease or rental payments or other amounts owed to US under this
              Agreement;
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(f)">
            <p
              style={{
                paddingLeft: "60pt",
                textIndent: "-18pt",
                textAlign: "justify"
              }}
            >
              Commence legal action for specific performance, replevin,
              sequestration, and delivery or the like related to the Vehicle. To
              the extent permitted by applicable law, YOU also hereby waive any
              rights now or hereafter conferred by statute or otherwise that may
              require US to sell, lease or otherwise use any property in
              mitigation of OUR damages hereunder.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={27}>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>
            Applicable Law, Jurisdiction, Jury Waiver, and Class/Collective Action
            Waiver
          </u>
          .
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l34">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Applicable Law.
              <span className="p">
                The Lease Documents shall be governed by and interpreted in
                accordance with the laws of the State of Tennessee and in the
                event of any disagreement or litigation, the laws of Tennessee
                shall apply without regard to conflict-of-laws principles.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Venue.
              <span className="p">
                The parties agree that any and all claims between the parties
                shall be brought exclusively in the federal or state courts of
                proper jurisdiction located in Davidson County, Tennessee;
                provided, however, the parties specifically agree that OUR claims
                for injunctive relief and/or specific performance may be brought
                in a court of proper jurisdiction, wherever located.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              <i>Scope. </i>For purposes of this Section 27, the term “claim” or
              “claims” shall mean and include any and all legal or factual
              disputes, claims, allegations, causes of action, demands,
              administrative proceedings or controversies arising, or having
              arisen, that in any way relate to or arise from this Agreement, YOUR
              business relationship with US and/or the termination of this
              Agreement or that business relationship, which could be brought in
              court, including, but not limited to, any and all claims under any
              federal, state, municipal and/or local minimum wage, overtime pay
              and/or wage payment laws, any federal, state, municipal and/or local
              law, rule, statute, ordinance or regulation, any claims based on any
              law, rule, statute, ordinance, regulation, public policy, contract,
              tort, or common law, misclassification claims or claims related to
              employment or independent contractor status, claims under the
              Truth-in-Leasing Regulations, 49 CFR <span className="s5">§</span>
              376.1 et. seq., claims of fraud or misrepresentation, both negligent
              and intentional; claims of procedural and substantive
              unconscionability, claims of unjust enrichment, claims of forced
              labor or involuntary servitude, claims of breach of contract and/or
              any claim for costs, fees and other expenses or relief, including
              attorneys’ fees.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              <i>Jury Trial Waiver</i>.
              <b>NOTWITHSTANDING ANY OTHER PROVISION CONTAINED HEREIN</b>,
              <b>
                BY SIGNING BELOW, LESSOR AND LESSEE EACH EXPRESSLY WAIVE ANY RIGHT
                TO A JURY TRIAL FOR ANY AND ALL CLAIMS.
              </b>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(e)">
            <p
              className="s7"
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                textAlign: "left"
              }}
            >
              Waiver of Class Action Rights.
            </p>
            <ol id="l35">
              <li data-list-text="(i)">
                <p
                  className="s7"
                  style={{
                    paddingTop: "3pt",
                    paddingLeft: "48pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  Scope.
                  <span className="p">
                    YOU AGREE TO WAIVE ALL RIGHTS TO BRING, OR BE A PARTY TO, ANY
                    PRE-EXISTING OR FUTURE CLASS, COLLECTIVE OR CONSOLIDATED
                    ACTION, AND/OR CLASS, COLLECTIVE OR CONSOLIDATED CLAIM(S),
                    AGAINST US AND AGREE TO PURSUE ANY PRE-EXISTING OR FUTURE
                    CLAIM(S) ON AN INDIVIDUAL BASIS ONLY UNDER THE TERMS OF THIS
                    AGREEMENT
                  </span>
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="(ii)">
                <p
                  className="s7"
                  style={{
                    paddingLeft: "47pt",
                    textIndent: "-17pt",
                    textAlign: "left"
                  }}
                >
                  Savings Clauses<span className="p">.</span>
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
                <ol id="l36">
                  <li data-list-text="(1)">
                    <p
                      className="s7"
                      style={{
                        paddingLeft: "50pt",
                        textIndent: "-18pt",
                        textAlign: "justify"
                      }}
                    >
                      Revision of Provisions.
                      <span className="p">
                        In the event that any provision of this Section shall be
                        construed as unlawful or unenforceable, and if the
                        offending provision can be deleted without affecting the
                        primary intention of the parties or can be reformed to
                        achieve the primary intention of the parties as expressed
                        herein, then the offending provision shall be so deleted
                        or reformed and the remainder of this Agreement shall
                        remain in full force and effect as written.
                      </span>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="(2)">
                    <p
                      className="s9"
                      style={{
                        paddingLeft: "50pt",
                        textIndent: "-18pt",
                        textAlign: "justify"
                      }}
                    >
                      Unenforceability.
                      <span className="h4">
                        IF THIS SECTION IS DETERMINED TO BE UNENFORCEABLE IN
                        WHOLE, ANY CLAIMS, AS DEFINED ABOVE, BETWEEN YOU AND US
                        SHALL BE SUBJECT TO A NON-JURY TRIAL IN THE FEDERAL COURT
                        HAVING JURISDICTION OVER DAVIDSON COUNTY, TENNESSEE OR IF
                        THE FEDERAL COURT DOES NOT HAVE JURISDICTION, THE STATE
                        COURTS SITUATED IN DAVIDSON COUNTY, TENNESSEE. BY SIGNING
                        BELOW, YOU AND US EACH EXPRESSLY WAIVE ANY RIGHT TO A JURY
                        TRIAL FOR ANY AND ALL CLAIMS.
                      </span>
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li data-list-text={28}>
        <p
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>Further Assurances</b>
          </u>
          . YOU will promptly execute and deliver to US such further reasonable
          documents and take such further reasonable actions as WE may request in
          order to more effectively carry out the intent and purpose of this
          Agreement or to accomplish an assignment of interest in this Agreement.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={29}>
        <p
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>Survival</b>
          </u>
          . Terms and provisions which by their nature would normally survive
          expiration or other termination of this Agreement shall so survive the
          expiration or other termination of the Agreement.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={30}>
        <p
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>Entire Agreement</b>
          </u>
          . This Agreement and the other Lease Documents, incorporated herein,
          contain the entire and final contract and agreement of the parties and
          shall not be qualified or supplemented by course of dealing.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={31}>
        <p
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>No Waivers</b>
          </u>
          . No waiver or modification by US of any of the terms or conditions of
          the Lease Documents shall be effective unless in writing and signed by
          US. No waiver by US of any deviation by YOU of any required performance
          shall be a waiver of OUR right to subsequent or other full and timely
          performance.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={32}>
        <p
          className="s6"
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          Enforcement.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l37">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Attorneys’ Fees and Costs.
              <span className="p">
                In the event a suit, claim, action or proceeding is commenced to
                enforce this Agreement or with respect to this Agreement, the
                prevailing non-breaching party shall be reimbursed by the other
                breaching party for all costs and expenses incurred in connection
                with the suit, claim or action, including, without limitation,
                reasonable attorneys’ fees at hearing or trial and on appeal.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Costs of Collection.
              <span className="p">
                YOU agree that in the event of default in the payment of any
                amount due by YOU to US and if this account is placed in the hands
                of an agency or attorney for collection or legal action, YOU will
                pay the cost of collection, attorneys’ fees and other costs
                incurred and permitted by law governing these transactions. A
                finance charge of 1.5% per month (18% annually) will be charged on
                balances over 30 days past due, or at the maximum rate allowed by
                applicable law.
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={33}>
        <p
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>Severability</b>
          </u>
          . Any provision of this Agreement which is unenforceable in any
          jurisdiction shall, as to such jurisdiction, be ineffective to the
          extent of such prohibition or unenforceability without invalidating the
          remaining provisions hereof; and any such prohibition or
          unenforceability in any jurisdiction shall not invalidate or render
          unenforceable such provision in any other jurisdiction; provided,
          however, that to the extent that the provisions of any such applicable
          law can be waived, they are waived by YOU.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={34}>
        <p
          style={{ paddingLeft: "23pt", textIndent: "-17pt", textAlign: "left" }}
        >
          <u>
            <b>Time of the Essence</b>
          </u>
          . Time is of the essence with respect to this Agreement.
        </p>
      </li>
      <li data-list-text={35}>
        <p
          style={{
            paddingTop: "3pt",
            paddingLeft: "23pt",
            textIndent: "-17pt",
            textAlign: "left"
          }}
        >
          <u>
            <b>Notice</b>
          </u>
          .
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l38">
          <li data-list-text="(a)">
            <p
              className="s7"
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              Method.
              <span className="p">
                Any notice, demand, or approval (“notice”) required or permitted
                to be given or obtained hereunder shall be in writing, and shall
                be sufficiently given or made if (i) delivered in person during
                normal business hours on a business day, (ii) sent by prepaid
                first class registered mail, or (iii) sent by any electronic means
                of sending messages, including facsimile transmission, in-cab
                message transmission (e.g. via the Platform Science, Omnitracs or
                Qualcomm systems), communications via any mobile or smartphone
                application, and electronic mail (each a “Electronic
                Transmission”), and addressed as follows:
              </span>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p
              style={{
                paddingLeft: "30pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              <u>To LESSOR at</u>:
            </p>
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "30pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              7135 Centennial Place
            </p>
            <p
              style={{
                paddingLeft: "30pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Nashville, TN 37209
            </p>
            <p
              style={{
                paddingLeft: "30pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Attn:
              <u>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"Erik Morrison"}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
              <br />
              Telephone No.:
              <u>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"615-846-6110"}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u><br/>
              Facsimile No.:
              <u>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u><br/>
              E-mail Address:
              <u>
                &nbsp;{"emorrison@westernexp.com"}&nbsp;
              </u>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p
              style={{
                paddingLeft: "30pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              <u>To LESSEE at</u>:
            </p>
            <p
              style={{ paddingTop: "10pt", textIndent: "15pt", textAlign: "right" }}
            >
              <u>{props.viewObject !== undefined ? props.viewObject.OwnerAddress1 : (props.ownerData!.address + " " + props.ownerData!.city + " " + props.ownerData!.state)}</u>
              <br />
            </p>
            <p
              style={{
                paddingLeft: "30pt",
                textIndent: "0pt",
                lineHeight: "1pt",
                textAlign: "left"
              }}
            >
              <span />
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p
              style={{
                paddingLeft: "30pt",
                textIndent: "0pt",
                lineHeight: "1pt",
                textAlign: "left"
              }}
            >
              <span />
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p
              style={{
                paddingLeft: "30pt",
                textIndent: "0pt",
                lineHeight: "1pt",
                textAlign: "left"
              }}
            >
              <span />
            </p>
            <p
              style={{
                paddingLeft: "30pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Attention:
              <u>
              { props.viewObject !== undefined ? props.viewObject.OwnerName1 : props.ownerData.name }
              </u><br/>
              Telephone No.:
              <u>
              { props.viewObject !== undefined ? props.viewObject.OwnerPhone : props.ownerData.phoneNumber.toString()}
              </u>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
              Facsimile No.:
              <u>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
                          <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
              E-mail Address:
              <u>
                { props.viewObject !== undefined ? props.viewObject.OwnerEmail : props.ownerData.email}
              </u>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "24pt",
                textIndent: "36pt",
                textAlign: "justify"
              }}
            >
              <i>Effectiveness. </i>Each notice sent in accordance with this
              Section shall be deemed to have been received (i) at the time and on
              the day it was hand delivered at such address, (ii) at 7:30 AM
              prevailing central standard time on the third (3
              <span className="s8">rd</span>) day after it was mailed (excluding
              each business day during which there existed any general
              interruption of postal services due to strike, lockout, or other
              cause), or (iii) the earlier of actual receipt or one hour after
              transmitting on the same day that it was sent by Electronic
              Transmission,. Either party may change its contact information for
              notice by giving notice to the other party as provided in this
              Section. Either Party’s use of alternate known addresses shall not
              affect the effectiveness of notices provided in compliance with this
              Section.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={36}>
        <h4
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>Amendment</u>.
          <span className="p">
            Subject to modification pursuant to Section 4(d) above, this Agreement
            may be amended in writing only, signed or authenticated by the party
            against which enforcement is sought.
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={37}>
        <p
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>Product of Negotiation</b>
          </u>
          . You agree and acknowledge that the Lease Documents are the product of
          negotiation between the parties and the provisions of each Lease
          Document are unambiguous; provided, however, that in the event an
          ambiguity is found to be contained in any Lease Document, neither party
          shall be deemed the “drafter” regarding such ambiguous provision.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={38}>
        <p
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>Authority</b>
          </u>
          . You further agree and acknowledge that you possess the requisite
          capacity and authority to enter into this Agreement.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={39}>
        <h4
          style={{
            paddingLeft: "24pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>Headings</u>.
          <span className="p">
            The headings and subheadings used in this Agreement have no
            substantive effect and are used for convenience only.
          </span>
        </h4>
      </li>
    </ol>
    <p
      className="s10"
      style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}
    >
      THIS AGREEMENT CONTAINS BINDING PROVISIONS REGARDING (i) CLASS, COLLECTIVE
      AND CONSOLIDATED ACTION WAIVERS AND (ii) JURY TRIAL WAIVER, THAT MAY BE
      ENFORCED BY THE
    </p>
    <p
      className="s10"
      style={{
        paddingLeft: "6pt",
        textIndent: "0pt",
        lineHeight: "13pt",
        textAlign: "left"
      }}
    >
      PARTIES. (See Section 27 above)
    </p>
    <h4
      style={{
        paddingTop: "3pt",
        paddingLeft: "6pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      LESSOR (“WE”)
    </h4>
    <p
      className="s11"
      style={{
        paddingTop: "7pt",
        paddingBottom: "1pt",
        paddingLeft: "6pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      
      &nbsp;&nbsp; New&nbsp; Horizon&nbsp; Leasing
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }} />
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      BY
    </h4>
    
    <p
      className="s12"
      style={{
        paddingTop: "7pt",
        paddingLeft: "6pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      <u> New Horizon Leasing Representative</u>
    </p>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      DATE: &nbsp;
      <u>
        {props.viewObject !== undefined ? props.viewObject.date1 : props.date}
      </u>
      , 20<u>{props.viewObject !== undefined ? props.viewObject.Year3 : props.year}</u>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    </h4>

    <h4
      style={{
        paddingTop: "3pt",
        paddingLeft: "6pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      LESSEE (“YOU”)
    </h4>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      BY
    </h4>
    {props.viewObject !== undefined ? <img src={props.signatureData} alt="Signature"/> : <div>________________________________</div>}
    <p
      className="s11"
      style={{
        paddingTop: "7pt",
        paddingBottom: "1pt",
        paddingLeft: "6pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      
      <u>{ props.viewObject !== undefined ? props.viewObject.OwnerName1 : props.ownerData.name }</u>
    </p>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      ADDRESS: &nbsp;
      <u>
      {props.viewObject !== undefined ? props.viewObject.OwnerAddress1 : (props.ownerData!.address + " " + props.ownerData!.city + " " + props.ownerData!.state)}
      </u>
    </h4>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      DATE: &nbsp;
      <u>
        {props.viewObject !== undefined ? props.viewObject.date1 : props.date}
      </u>
      , 20<u>{props.viewObject !== undefined ? props.viewObject.Year3 : props.year}</u>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    </h4>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      CONTRACTOR is a resident of the State of &nbsp;
      <u>
        {props.viewObject !== undefined ? props.viewObject.OwnerState : props.ownerData!.state}
      </u>
      .
    </h4>
    <p style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <div
      className="textbox"
      style={{
        border: "0.8pt solid #000000",
        display: "block",
        minHeight: "43.5pt",
        width: "465.8pt"
      }}
    >
      <p
        className="s1"
        style={{
          paddingTop: "3pt",
          paddingLeft: "22pt",
          textIndent: "-10pt",
          textAlign: "left"
        }}
      >
        This lease may have been collaterally assigned to a secured party, and if
        so, any purchase or assignment of this lease would violate the rights of
        the secured party. Inquire with Lessor if you have any questions.
      </p>
    </div>
    <p style={{ paddingLeft: "43pt", textIndent: "0pt", textAlign: "left" }} />
    <h2 style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "center" }}>
      SCHEDULE A – VEHICLE, TERMS AND PAYMENT
    </h2>
    <p style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      style={{
        paddingLeft: "6pt",
        textIndent: "0pt",
        lineHeight: "11pt",
        textAlign: "left"
      }}
    >
      This is SCHEDULE A to the LEASE AGREEMENT WITH OPTION TO PURCHASE (the
      “Agreement”) between
    </p>
    <p
      style={{
        paddingLeft: "6pt",
        textIndent: "0pt",
        lineHeight: "12pt",
        textAlign: "left"
      }}
    >
      <span className="s2">
        
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <u>
        New Horizons Leasing
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      . (hereinafter “Lessor”, “WE”, “US” or “OUR”), and
    </p>
    <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      <span className="s2">
        <u>{ props.viewObject !== undefined ? props.viewObject.OwnerName1 : props.ownerData.name }</u>
      </span>
      (hereinafter the “Lessee”, “YOU” or “YOUR”) dated
      <span className="s2">
        <u>{props.viewObject !== undefined ? props.viewObject.date1 : currentDate.slice(5,10).toString()}</u>
      </span>
      , 20<span className="s2"> {props.viewObject !== undefined ? props.viewObject.Year3 : currentYear} </span>.
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <table
      style={{ borderCollapse: "collapse", marginLeft: "6.25pt" }}
      cellSpacing={0}
    >
      <tbody>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s13"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              LEASED/PURCHASED VEHICLE
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Unit Number:
            </p>
            <u>{props.viewObject ? props.viewObject.UnitNumber1 : userInfo.unit}</u>
          </td>
        </tr>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Description of Vehicle (Make/Model/Year):
            </p>
            {/* {console.log("model", props.unitData!.unit.UNMAKE.trim(), props.unitData!.unit.UNMAKE)} */}
            <u>{ props.viewObject !== undefined ? props.viewObject.Make1 : `${props.unitData!.unit.UNMAKE.trim()} ${props.unitData!.unit.UNMAKE.trim() === 'FRHT' ? "Cascadia" : "Prostar"} ${props.unitData!.unit.UNYEAR}`}</u>
          </td>
        </tr>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Vehicle Identification Number:
            </p>
            <u>{props.viewObject! !== undefined ? props.viewObject.VIN! : props.unitData!.unit.UNSER}</u>
          </td>
        </tr>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Mileage Statement:
            </p>
            <u>{props.viewObject !== undefined ? props.viewObject.MileageStatement : props.mileageStatement}</u>
          </td>
        </tr>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s13"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              LEASE PAYMENT TERMS
            </p>
            <u>{props.viewObject !== undefined ? props.viewObject.NumberofPayments : props.tierTable.Term}</u>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Lease Payment Amount:
            </p>
            <u>${props.viewObject !== undefined ? props.viewObject.PaymentAmount : props.tierTable.Weekly}</u>
          </td>
        </tr>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Frequency of Lease Payment: <span className="s15">Weekly</span>
            </p>
          </td>
        </tr>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Date of 1<span className="s16">st</span> Lease Payment:
            </p>
            <u>{props.viewObject !== undefined ? props.viewObject.DateofFirst : props.nextFriday}</u>
          </td>
        </tr>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Number of Total Lease Payments:
            </p>
            <u>{props.viewObject !== undefined ? props.viewObject.NumberofPayments : props.tierTable.Term}</u>
          </td>
        </tr>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s13"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              PURCHASE TERMS
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Purchase Price:
            </p>
            <u>{props.viewObject !== undefined ? props.viewObject.PurchasePrice : props.tierTable.Purchase}</u>
          </td>
        </tr>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s13"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              MILEAGE PAYMENT:
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Five cents ($0.05) per mile over 10,000 miles in any period
            </p>
          </td>
        </tr>
        <tr style={{ height: "19pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              Due: occurrence
            </p>
          </td>
        </tr>
        <tr style={{ height: "32pt" }}>
          <td
            style={{
              width: "216pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s13"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              APPLICABLE INTEREST (on payments due in excess of 30 days):
            </p>
          </td>
          <td
            style={{
              width: "324pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s14"
              style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
            >
              1.5% annual interest (or the maximum amount permitted by applicable
              law)
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      The parties have executed this SCHEDULE A on &nbsp;
      <u>
        {props.viewObject !== undefined ? props.viewObject.date1 : props.date}
      </u>
      , 20<u>{props.viewObject !== undefined ? props.viewObject.Year3 : props.year}</u>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <span />
    </p>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      LESSEE (“YOU”)
    </h4>
      <u>
        By:
        {props.viewObject !== undefined ? <img src={props.signatureData} alt="Signature"/> : <div>________________________________</div>}
      </u>
      <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <u>
        Title:
        {"IndependentContractor"}
      </u>
      <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      LESSOR (“WE”)
    </h4>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      <u>
        By:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
    </h4>
    <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s18"
      style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}
    >
    <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
      <u>
        Title: <span className="s12">New Horizon Leasing Representative</span>
      </u>
    </p>
    <p
      style={{
        paddingLeft: "258pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      <span />
    </p>
    <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s6"
      style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}
    >
      Ownercode:
      <u>{localStorage.getItem("username")}</u>
    </p>
    <p style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s6"
      style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}
    >
      Drivercode:
      <u>{localStorage.getItem("driverCode")}</u>
    </p>
    <h2 style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "center" }}>
      SCHEDULE B – MOTOR CARRIER AUTHORITY
    </h2>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      style={{
        paddingLeft: "6pt",
        textIndent: "0pt",
        lineHeight: "11pt",
        textAlign: "left"
      }}
    >
      This is SCHEDULE B to the LEASE AGREEMENT WITH OPTION TO PURCHASE (the
      “Agreement”) between
    </p>
    <p
      style={{
        paddingLeft: "6pt",
        textIndent: "0pt",
        lineHeight: "12pt",
        textAlign: "left"
      }}
    >
      <span className="s2">
        
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <u>
        New Horizons Leasing
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      . (hereinafter “Lessor”, “WE”, “US” or “OUR”), and
    </p>
    <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      <span className="s2">
        <u>{ props.viewObject !== undefined ? props.viewObject.OwnerName1 : props.ownerData.name }</u>
      </span> &nbsp;
      (hereinafter the “Lessee”, “YOU” or “YOUR”) dated
      <span className="s2">
        <u>{props.viewObject !== undefined ? props.viewObject.date1 : currentDate.slice(5,10).toString()}</u>
      </span>
      , 20<span className="s2"> {props.viewObject !== undefined ? props.viewObject.Year3 : currentYear} </span>.
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      Lessee has entered into a lease agreement (pursuant to 49 C.F.R. § 376.11
      and 376.12) with the following motor carrier:
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <table
      style={{ borderCollapse: "collapse", marginLeft: "6.25pt" }}
      cellSpacing={0}
    >
      <tbody>
        <tr style={{ height: "12pt" }}>
          <td
            style={{
              width: "207pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s19"
              style={{
                paddingLeft: "5pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              MOTOR CARRIER INFORMATION
            </p>
          </td>
          <td
            style={{
              width: "333pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s19"
              style={{
                paddingLeft: "5pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              NAME: <span className="s20">Western Express</span>
            </p>
          </td>
        </tr>
        <tr style={{ height: "12pt" }}>
          <td
            style={{
              width: "207pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "333pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s19"
              style={{
                paddingLeft: "5pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              MC#: <span className="s20">260323</span>
            </p>
          </td>
        </tr>
        <tr style={{ height: "12pt" }}>
          <td
            style={{
              width: "207pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "333pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s19"
              style={{
                paddingLeft: "5pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              FMCSA SAFETY RATING: Satisfactory
            </p>
          </td>
        </tr>
        <tr style={{ height: "12pt" }}>
          <td
            style={{
              width: "207pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "333pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s19"
              style={{
                paddingLeft: "5pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              ADDRESS: <span className="s20">7135 Centennial Place</span>
            </p>
          </td>
        </tr>
        <tr style={{ height: "12pt" }}>
          <td
            style={{
              width: "207pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "333pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s20"
              style={{
                paddingLeft: "63pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              Nashville, TN 37209
            </p>
          </td>
        </tr>
        <tr style={{ height: "12pt" }}>
          <td
            style={{
              width: "207pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "333pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
        </tr>
        <tr style={{ height: "12pt" }}>
          <td
            style={{
              width: "207pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "333pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s19"
              style={{
                paddingLeft: "5pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              PHONE: <span className="s20">615-846-6110</span>
            </p>
          </td>
        </tr>
        <tr style={{ height: "12pt" }}>
          <td
            style={{
              width: "207pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "333pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s19"
              style={{
                paddingLeft: "5pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              CONTACT: <span className="s20">Erik Morrison</span>
            </p>
          </td>
        </tr>
        <tr style={{ height: "12pt" }}>
          <td
            style={{
              width: "207pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </td>
          <td
            style={{
              width: "333pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              style={{
                paddingLeft: "5pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              <a
                href="mailto:emorrison@newhorizonlp.com"
                style={{
                  color: "black",
                  fontFamily: "Arial, sans-serif",
                  fontStyle: "normal",
                  fontWeight: "bold",
                  textDecoration: "none",
                  fontSize: "10pt"
                }}
                target="_blank"
              >
                EMAIL ADDRESS:
              </a>
              <a
                href="mailto:emorrison@newhorizonlp.com"
                className="s21"
                target="_blank"
              >
                emorrison@newhorizonlp.com
              </a>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      Prior to hauling any load under Carrier’s authority, Lessee shall provide to
      Lessor a copy of the lease agreement between Lessee and Carrier.
    </p>
    <p
      style={{
        paddingTop: "11pt",
        paddingLeft: "6pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      This Schedule B is subject to modification or amendment as provided under
      Section 18(b) of the Agreement.
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      LESSEE (“YOU”)
    </h4>
      <u>
        By:
        { props.viewObject !== undefined ? props.viewObject.OwnerName1 : props.ownerData.name }
      </u>
      <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <u>
        Title:
        {"IndependentContractor"}
      </u>
      <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
      LESSOR (“WE”)
    </h4>
    <h4 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        By:
        {props.viewObject !== undefined ? <img src={props.signatureData} alt="Signature"/> : <div>________________________________</div>}
    </h4>
    <p
      className="s18"
      style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}
    >
    <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
      <u>
        Title: <span className="s12">New Horizon Leasing Representative</span>
      </u>
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s6"
      style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}
    >
      Ownercode:
      <u>{localStorage.getItem("username")}</u>
    </p>
    <p style={{ paddingTop: "9pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s6"
      style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}
    >
      Drivercode:
      {localStorage.getItem("driverCode")}
      _
    </p>
    <p
      className="s5"
      style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "right" }}
    >
      Watermarked Example
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h2 style={{ textIndent: "0pt", textAlign: "center" }}>
      SCHEDULE C – SHORT-TERM TRACTOR RENTAL
    </h2>
    <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <span />
    </p>
    <p style={{ paddingLeft: "6pt", textIndent: "18pt", textAlign: "justify" }}>
      This Short-Term Tractor Rental Agreement (“Rental Agreement”) is attached to
      and forms a part of the “Lease Agreement” between New Horizons Leasing, LLC,
      a Tennessee limited liability corporation (“Lessor”), having its principle
      offices at 7135 Centennial Place, Nashville, TN 37209 and
      <span className="s2">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      (“Lessee”), having its principle offices or mailing address at
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      .
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h4 style={{ paddingLeft: "6pt", textIndent: "18pt", textAlign: "justify" }}>
      WHEREAS
      <span className="p">
        , the vehicle which is the subject of the Lease Agreement between the
        parties is not operational due to the following mechanical or other
        business-related interruptions (the “Inoperable Vehicle”):
      </span>
      <span className="s2">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </h4>
    <p
      style={{
        paddingLeft: "6pt",
        textIndent: "0pt",
        lineHeight: "11pt",
        textAlign: "left"
      }}
    >
      <u>
        
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      ; and
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h4 style={{ paddingLeft: "6pt", textIndent: "18pt", textAlign: "justify" }}>
      WHEREAS
      <span className="p">
        , Lessee desires for his/her convenience and continuity of business
        operations, and not as a requirement of Lessor, to utilize additional
        equipment of Lessor on a short-term basis;
      </span>
    </h4>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h4 style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "left" }}>
      NOW THEREFORE
      <span className="p">
        , in consideration of the mutual promises contained in this Agreement, the
        parties agree as follows:
      </span>
    </h4>
    <ol id="l39">
      <li data-list-text={1}>
        <h4
          style={{
            paddingTop: "11pt",
            paddingLeft: "42pt",
            textIndent: "-18pt",
            textAlign: "left"
          }}
        >
          <u>RENTAL AND PAYMENT TERMS.</u>
          <span className="p">
            Lessor may make available to Lessee the vehicle described below,
            together with all attachments, accessories, replacement parts, and
            additions thereto (collectively the “Vehicle”) in exchange for the
            rental payments indicated below for the purpose of engaging in the
            independent business of transporting freight for motor carrier
            companies and other persons and entities. For clarity, the Vehicle is
            provided without any benefits other than possession, the Lessee
            remains responsible for all aspects of operation of the Vehicle, and
            the purpose of this Rental Agreement is limited to replacing the
            Inoperable Vehicle for a temporary period so Lessee can continue its
            operations under the Lease Agreement and any hauling agreement.
          </span>
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <table
          style={{ borderCollapse: "collapse", marginLeft: "46.594pt" }}
          cellSpacing={0}
        >
          <tbody>
            <tr style={{ height: "12pt" }}>
              <td
                style={{
                  width: "252pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt"
                }}
              >
                <p
                  className="s20"
                  style={{
                    paddingLeft: "5pt",
                    textIndent: "0pt",
                    lineHeight: "11pt",
                    textAlign: "left"
                  }}
                >
                  Vehicle Identification Number (VIN#):
                </p>
              </td>
              <td
                style={{
                  width: "207pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt"
                }}
              >
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </td>
            </tr>
            <tr style={{ height: "12pt" }}>
              <td
                style={{
                  width: "252pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt"
                }}
              >
                <p
                  className="s20"
                  style={{
                    paddingLeft: "5pt",
                    textIndent: "0pt",
                    lineHeight: "11pt",
                    textAlign: "left"
                  }}
                >
                  Description of Vehicle (Make/Model/Year/Unit#):
                </p>
              </td>
              <td
                style={{
                  width: "207pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt"
                }}
              >
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </td>
            </tr>
            <tr style={{ height: "12pt" }}>
              <td
                style={{
                  width: "252pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt"
                }}
              >
                <p
                  className="s20"
                  style={{
                    paddingLeft: "5pt",
                    textIndent: "0pt",
                    lineHeight: "11pt",
                    textAlign: "left"
                  }}
                >
                  Mileage Statement:
                </p>
              </td>
              <td
                style={{
                  width: "207pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt"
                }}
              >
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </td>
            </tr>
            <tr style={{ height: "12pt" }}>
              <td
                style={{
                  width: "252pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt"
                }}
              >
                <p
                  className="s20"
                  style={{
                    paddingLeft: "5pt",
                    textIndent: "0pt",
                    lineHeight: "11pt",
                    textAlign: "left"
                  }}
                >
                  Date Rental Agreement Begins:
                </p>
              </td>
              <td
                style={{
                  width: "207pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt"
                }}
              >
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </td>
            </tr>
            <tr style={{ height: "12pt" }}>
              <td
                style={{
                  width: "252pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt"
                }}
              >
                <p
                  className="s20"
                  style={{
                    paddingLeft: "5pt",
                    textIndent: "0pt",
                    lineHeight: "11pt",
                    textAlign: "left"
                  }}
                >
                  Rental Rate:
                </p>
              </td>
              <td
                style={{
                  width: "207pt",
                  borderTopStyle: "solid",
                  borderTopWidth: "1pt",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1pt",
                  borderBottomStyle: "solid",
                  borderBottomWidth: "1pt",
                  borderRightStyle: "solid",
                  borderRightWidth: "1pt"
                }}
              >
                <p
                  className="s20"
                  style={{
                    paddingLeft: "5pt",
                    textIndent: "0pt",
                    lineHeight: "11pt",
                    textAlign: "left"
                  }}
                >
                  $100.00 per day
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={2}>
        <h4
          style={{ paddingLeft: "42pt", textIndent: "-18pt", textAlign: "left" }}
        >
          <u>TERM &amp; TERMINATION.</u>
          <span className="p">
            This Addendum shall commence on the date of execution and remain in
            effect until Termination by either party as provided herein.
          </span>
        </h4>
        <ol id="l40">
          <li data-list-text="A.">
            <h4
              style={{
                paddingTop: "11pt",
                paddingLeft: "60pt",
                textIndent: "-18pt",
                textAlign: "left"
              }}
            >
              <u>Termination by Lessee.</u>
              <span className="p">
                Lessee may terminate this Addendum at any time by returning the
                Vehicle to a location reasonably indicated by Lessor and remitting
                all rental payments due and owing.
              </span>
            </h4>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="B.">
            <h4
              style={{
                paddingLeft: "60pt",
                textIndent: "-18pt",
                textAlign: "left"
              }}
            >
              <u>Termination by Lessor.</u>
              <span className="p">
                Lessor may terminate this Addendum at any time upon five (5)
                calendar days’ notice to Lessee, such notice to be given as
                provided in the Lease Agreement between the parties.
              </span>
            </h4>
          </li>
        </ol>
      </li>
      <li data-list-text={3}>
        <p
          style={{
            paddingTop: "11pt",
            paddingLeft: "42pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>REMAINING LEASE AGREEMENT TERMS.</b>
          </u>
          <b> </b>Any conflict between this Addendum and the Agreement will be
          resolved in favor of this Addendum. All responsibilities, liabilities,
          and obligations of Lessee under the Lease Agreement,
          <u>
            <b>INCLUDING THE OBLIGATION TO MAKE TIMELY LEASE PAYMENTS</b>
          </u>
          , remain in effect during the duration of this Rental Addendum, and are
          hereby incorporated herein by reference.
        </p>
      </li>
    </ol>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h4 style={{ paddingLeft: "42pt", textIndent: "0pt", textAlign: "left" }}>
      <u>
        By signing this Addendum, Lessee acknowledges and agrees that Lessee has
        been given the opportunity
      </u>
      <u>
        to inspect the Vehicle prior to signing this Addendum and that the Vehicle
        is acceptable to Lessee.
      </u>
    </h4>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h4 style={{ paddingLeft: "42pt", textIndent: "0pt", textAlign: "left" }}>
      New Horizons Leasing, LLC LESSEE: 7135 Centennial Place
    </h4>
    <h4
      style={{
        paddingLeft: "42pt",
        textIndent: "0pt",
        lineHeight: "11pt",
        textAlign: "left"
      }}
    >
      Nashville, TN 37209
    </h4>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      style={{
        paddingLeft: "294pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      <span />
    </p>
    <p
      style={{
        paddingTop: "11pt",
        paddingLeft: "42pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      By:
      {props.viewObject !== undefined ? <img src={props.signatureData} alt="Signature"/> : <div>________________________________</div>}
    </p>
    <p
      style={{
        paddingLeft: "294pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      <span />
    </p>
    <p
      style={{
        paddingTop: "10pt",
        paddingLeft: "42pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      Title:
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
    </p>
    <p
      style={{
        paddingLeft: "294pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      <span />
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <span />
    </p>
    <p
      className="s5"
      style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "right" }}
    >
      Watermarked Example
    </p>
    <p style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h2 style={{ textIndent: "0pt", textAlign: "center" }}>
      SCHEDULE D – BASE PAYMENT DEFERRAL AGREEMENT
    </h2>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s22"
      style={{ paddingLeft: "24pt", textIndent: "18pt", textAlign: "justify" }}
    >
      This Lease Payment Deferral Agreement (“Deferral Agreement”) is attached to
      and forms a part of the “Lease Agreement” between New Horizons Leasing, LLC,
      a Tennessee limited liability corporation (“Lessor”), having its principle
      offices at 7135 Centennial Place, Nashville, TN 37209 and
    </p>
    <p
      className="s24"
      style={{
        paddingLeft: "24pt",
        textIndent: "0pt",
        lineHeight: "13pt",
        textAlign: "justify"
      }}
    >
      <u>
        
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      <span className="s22">
        (“Lessee”), having its principle offices or mailing address at
      </span>
    </p>
    <p
      className="s22"
      style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "justify" }}
    >
      <u>
        
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      . All capitalized terms shall have the meanings ascribed to them in the
      Lease Agreement.
    </p>
    <h3
      style={{
        paddingTop: "12pt",
        paddingLeft: "24pt",
        textIndent: "18pt",
        textAlign: "justify"
      }}
    >
      WHEREAS
      <span className="s22">
        , Lessee has requested to defer a Base Payment otherwise due under
        Schedule A of the Agreement; and
      </span>
    </h3>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h3 style={{ paddingLeft: "42pt", textIndent: "0pt", textAlign: "left" }}>
      WHEREAS
      <span className="s22">
        , Lessor has agreed to defer such lease payment at Lessor’s request;
      </span>
    </h3>
    <h3
      style={{
        paddingTop: "12pt",
        paddingLeft: "24pt",
        textIndent: "18pt",
        textAlign: "justify"
      }}
    >
      NOW THEREFORE
      <span className="s22">
        , in consideration of the mutual promises contained in this Agreement, the
        parties agree as follows:
      </span>
    </h3>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <ol id="l41">
      <li data-list-text={1}>
        <h3
          style={{
            paddingLeft: "60pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>DEFERRED PAYMENT.</u>
          <span className="s22">
            Lessor shall defer Lessee’s Base Payment of the Agreement in the
            amount of AMOUNT, otherwise due on DATE, by extending the term of
            Schedule A by one additional week, subject to earlier termination as
            result of the terms and conditions of the Lease Agreement.
          </span>
        </h3>
      </li>
      <li data-list-text={2}>
        <h3
          style={{
            paddingTop: "12pt",
            paddingLeft: "60pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>EFFECT OF DEFERRED PAYMENT.</u>
          <span className="s22">
            As provided in Section 4(d)(ii) of the Agreement, this deferment shall
            (i) extend the Term by one week from the currently scheduled end date
            of the Lease, and (ii) defer the due date of such deferred Base
            Payment until the earliest of: (A) the occurrence of an Event of
            Default, at which point the aggregate of all such deferred Base
            Payments shall be immediately due and payable, (B) YOUR termination of
            this Agreement pursuant to Section 3(b) above, at which point the
            aggregate amount of all such deferred Base Payments shall be
            immediately due and payable, (C) the satisfaction of the requirements
            set forth in Section 18(b) to haul for a New Carrier, or (D) the
            extended due date described in Section 1 above.
          </span>
        </h3>
      </li>
    </ol>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h3
      style={{
        paddingLeft: "42pt",
        textIndent: "0pt",
        lineHeight: "13pt",
        textAlign: "left"
      }}
    >
      New Horizons Leasing, LLC LESSEE:
    </h3>
    <h3
      style={{
        paddingLeft: "42pt",
        textIndent: "0pt",
        lineHeight: "13pt",
        textAlign: "left"
      }}
    >
      7135 Centennial Place
    </h3>
    <h3 style={{ paddingLeft: "42pt", textIndent: "0pt", textAlign: "left" }}>
      Nashville, TN 37209
    </h3>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      style={{
        paddingLeft: "294pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      <span />
    </p>
    <p
      className="s22"
      style={{
        paddingTop: "12pt",
        paddingLeft: "42pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      By:
      <u>
        &nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;
      </u>
      <u>
        &nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;
      </u>
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s22"
      style={{ paddingLeft: "42pt", textIndent: "0pt", textAlign: "left" }}
    >
      Title:
      <u>
        &nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;
      </u>
      <u>
        &nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;
      </u>
    </p>
    <p
      className="s5"
      style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "right" }}
    >
      Watermarked Example
    </p>
    <p
      className="s26"
      style={{
        paddingTop: "5pt",
        textIndent: "0pt",
        lineHeight: "13pt",
        textAlign: "center"
      }}
    >
      SCHEDULE E –
    </p>
    <p
      className="s26"
      style={{ textIndent: "0pt", lineHeight: "13pt", textAlign: "center" }}
    >
      ADDITIONAL PAYMENT DEFERRAL AGREEMENT/PAYMENT PLAN
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <span />
    </p>
    <p
      className="s22"
      style={{ paddingLeft: "24pt", textIndent: "18pt", textAlign: "justify" }}
    >
      This Payment Deferral Agreement No.
      <span className="s23">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>(“Deferral
      Agreement”) is attached to and forms a part of the “Lease Agreement” between
      New Horizons Leasing, LLC, a Tennessee limited liability corporation
      (“Lessor”), having its principle offices at 7135 Centennial Place,
      Nashville, TN 37209 and
    </p>
    <p
      className="s24"
      style={{
        paddingLeft: "24pt",
        textIndent: "0pt",
        lineHeight: "13pt",
        textAlign: "justify"
      }}
    >
      <u>
        
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      <span className="s22">
        (“Lessee”), having its principle offices or mailing address at
      </span>
    </p>
    <p
      className="s22"
      style={{ paddingLeft: "24pt", textIndent: "0pt", textAlign: "justify" }}
    >
      <u>
        
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      . All capitalized terms shall have the meanings ascribed to them in the
      Lease Agreement.
    </p>
    <h3
      style={{
        paddingTop: "12pt",
        paddingLeft: "24pt",
        textIndent: "18pt",
        textAlign: "justify"
      }}
    >
      WHEREAS
      <span className="s22">
        , Lessee has requested to defer an Additional Payment otherwise due under
        the Lease Agreement; and
      </span>
    </h3>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h3 style={{ paddingLeft: "24pt", textIndent: "18pt", textAlign: "justify" }}>
      WHEREAS
      <span className="s22">
        , Lessor has agreed to defer such lease payment at Lessor’s request on the
        terms and conditions contained herein;
      </span>
    </h3>
    <h3
      style={{
        paddingTop: "12pt",
        paddingLeft: "24pt",
        textIndent: "18pt",
        textAlign: "justify"
      }}
    >
      NOW THEREFORE
      <span className="s22">
        , in consideration of the mutual promises contained in this Agreement, the
        parties agree as follows:
      </span>
    </h3>
    <ol id="l42">
      <li data-list-text={1}>
        <h3
          style={{
            paddingTop: "12pt",
            paddingLeft: "60pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>DEFERRED PAYMENT.</u>
          <span className="s22">
            Lessor shall defer Lessee’s Additional Payment/s in the following
            amounts, which total AMOUNT (the “Deferred Amount”), otherwise due on
            DATE, which are acknowledged by Lessee as true and correct:
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l43">
          <li data-list-text="a.">
            <p
              className="s22"
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                textAlign: "left"
              }}
            >
              Mileage Payments: $
              <u>
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
            </p>
          </li>
          <li data-list-text="b.">
            <p
              className="s22"
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                lineHeight: "13pt",
                textAlign: "left"
              }}
            >
              Maintenance: $
              <u>
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
            </p>
          </li>
          <li data-list-text="c.">
            <p
              className="s22"
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                lineHeight: "13pt",
                textAlign: "left"
              }}
            >
              Licenses/Permits/Taxes: $
              <u>
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
            </p>
          </li>
          <li data-list-text="d.">
            <p
              className="s22"
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                lineHeight: "13pt",
                textAlign: "left"
              }}
            >
              Return Costs/Fees
            </p>
            <ol id="l44">
              <li data-list-text="i.">
                <p
                  className="s22"
                  style={{
                    paddingLeft: "50pt",
                    textIndent: "-14pt",
                    lineHeight: "13pt",
                    textAlign: "left"
                  }}
                >
                  Repair to Trade Terms: $
                  <u>
                    
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </u>
                </p>
              </li>
              <li data-list-text="ii.">
                <p
                  className="s22"
                  style={{
                    paddingLeft: "50pt",
                    textIndent: "-16pt",
                    lineHeight: "13pt",
                    textAlign: "left"
                  }}
                >
                  Recovery Fee: $
                  <u>
                    
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </u>
                </p>
              </li>
              <li data-list-text="iii.">
                <p
                  className="s22"
                  style={{
                    paddingLeft: "50pt",
                    textIndent: "-19pt",
                    lineHeight: "13pt",
                    textAlign: "left"
                  }}
                >
                  Liquidated Damages: $
                  <u>
                    
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </u>
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="e.">
            <p
              className="s22"
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                lineHeight: "13pt",
                textAlign: "left"
              }}
            >
              Insurance: $
              <u>
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
            </p>
          </li>
          <li data-list-text="f.">
            <p
              className="s22"
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                lineHeight: "13pt",
                textAlign: "left"
              }}
            >
              Indemnity: $
              <u>
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
            </p>
          </li>
          <li data-list-text="g.">
            <p
              className="s22"
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                lineHeight: "13pt",
                textAlign: "left"
              }}
            >
              Other (describe): $
              <u>
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
            </p>
          </li>
          <li data-list-text="h.">
            <p
              className="s22"
              style={{
                paddingLeft: "45pt",
                textIndent: "-17pt",
                lineHeight: "13pt",
                textAlign: "left"
              }}
            >
              Prior Additional Deferred Payments $
              <u>
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <h3
              style={{
                paddingLeft: "66pt",
                textIndent: "0pt",
                textAlign: "center"
              }}
            >
              YOU MAY HAVE ONLY ONE (1) OUTSTANDING ADDITIONAL PAYMENT DEFERRAL
              AGREEMENT AT ANY GIVEN TIME. ALL DEFERRED ADDITIONAL PAYMENTS WILL
              BE CONSOLIDATED INTO ONE ADDITIONAL DEFERRED PAYMENT AGREEMENT.
            </h3>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={2}>
        <h3
          style={{
            paddingLeft: "60pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>PAYMENT TERMS.</u>
          <span className="s22">
            As provided in Section 13 of the Lease Agreement, you agree and hereby
            authorize and direct Lessor to make deductions from escrow amounts and
            contract settlements in order to satisfy the Deferred Amount. When
            deductions are made from contract settlements pursuant to these
            extended terms, such deductions shall be made in the following manner:
          </span>
        </h3>
        <ol id="l45">
          <li data-list-text="a.">
            <p
              className="s22"
              style={{
                paddingTop: "12pt",
                paddingLeft: "60pt",
                textIndent: "0pt",
                lineHeight: "199%",
                textAlign: "justify"
              }}
            >
              A weekly payment of not less than $
              <span className="s23"> &nbsp;&nbsp;&nbsp;&nbsp; </span>per week (the
              “Minimum Payment”) plus (as applicable)
              <span className="s27"></span>
              <span className="s24"> </span>Check if Applicable
            </p>
            <p
              className="s22"
              style={{
                paddingLeft: "36pt",
                textIndent: "-18pt",
                textAlign: "justify"
              }}
            >
              <b>B. </b>An “Excess Payment” equal to
              <span className="s23">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <span className="s24"> </span>[
              <u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>%] of the Excess
              Revenues for the week as follows, but in no event shall the Excess
              Payment render the net settlement payable to YOU less than
              <u>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
              ($
              <u>
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </u>
              )] in a given week:
            </p>
            <p
              className="s5"
              style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "right" }}
            >
              Watermarked Example
            </p>
            <p
              style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}
            >
              <br />
            </p>
            <ol id="l46">
              <li data-list-text="I.">
                <p
                  className="s22"
                  style={{
                    paddingLeft: "50pt",
                    textIndent: "-15pt",
                    textAlign: "justify"
                  }}
                >
                  “Excess Revenues” means any positive amount of revenues in
                  excess of the amount needed to satisfy (i) the regularly
                  scheduled Base Payments and Mileage Payments, if any, due that
                  week under the Lease Agreement (other than the Deferred Amount),
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <span />
                </p>
                <p
                  className="s22"
                  style={{
                    paddingLeft: "50pt",
                    textIndent: "0pt",
                    textAlign: "justify"
                  }}
                >
                  (ii) the regularly scheduled escrow amount deductions pursuant
                  to the Lease Agreement and any applicable hauling agreement, and
                  (iii) the Minimum Payment, in each case regardless of whether
                  such deductions are actually made. For the avoidance of doubt,
                  if the Excess Revenues are equal to zero or are negative, no
                  payment is due that week.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="II.">
                <p
                  className="s22"
                  style={{
                    paddingLeft: "50pt",
                    textIndent: "-18pt",
                    textAlign: "justify"
                  }}
                >
                  <u>
                    <i>
                      <b>EXAMPLE</b>
                    </i>
                  </u>
                  , IF DEFERRED AMOUNT WERE $2,500.00 (NOTE: OTHER AMOUNTS ASSUMED
                  AND PROVIDED FOR ILLUSTRATIVE PURPOSES ONLY):
                </p>
                <p
                  style={{
                    paddingTop: "1pt",
                    textIndent: "0pt",
                    textAlign: "left"
                  }}
                >
                  <br />
                </p>
                <table
                  style={{ borderCollapse: "collapse", marginLeft: "37.52pt" }}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr style={{ height: "13pt" }}>
                      <td style={{ width: "245pt" }}>
                        <p
                          className="s13"
                          style={{
                            paddingLeft: "2pt",
                            textIndent: "0pt",
                            lineHeight: "12pt",
                            textAlign: "left"
                          }}
                        >
                          1. <span className="s14">GROSS REVENUES FOR WEEK:</span>
                        </p>
                      </td>
                      <td style={{ width: "136pt" }}>
                        <p
                          className="s14"
                          style={{
                            paddingLeft: "27pt",
                            textIndent: "0pt",
                            lineHeight: "12pt",
                            textAlign: "left"
                          }}
                        >
                          $ 2,000.00
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "13pt" }}>
                      <td style={{ width: "245pt" }}>
                        <p
                          className="s13"
                          style={{
                            paddingLeft: "2pt",
                            textIndent: "0pt",
                            lineHeight: "12pt",
                            textAlign: "left"
                          }}
                        >
                          2.
                          <span className="s14">
                            ORDINARY COURSE BASE PAYMENT
                          </span>
                        </p>
                      </td>
                      <td style={{ width: "136pt" }}>
                        <p
                          className="s14"
                          style={{
                            paddingLeft: "27pt",
                            textIndent: "0pt",
                            lineHeight: "12pt",
                            textAlign: "left"
                          }}
                        >
                          $ -750.00
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "13pt" }}>
                      <td style={{ width: "245pt" }}>
                        <p
                          className="s13"
                          style={{
                            paddingLeft: "2pt",
                            textIndent: "0pt",
                            lineHeight: "12pt",
                            textAlign: "left"
                          }}
                        >
                          3. <span className="s14">ORDINARY COURSE ESCROW</span>
                        </p>
                      </td>
                      <td style={{ width: "136pt" }}>
                        <p
                          className="s14"
                          style={{
                            paddingLeft: "27pt",
                            textIndent: "0pt",
                            lineHeight: "12pt",
                            textAlign: "left"
                          }}
                        >
                          $ -300.00
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: "12pt" }}>
                      <td
                        style={{
                          width: "245pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt"
                        }}
                      >
                        <p
                          className="s13"
                          style={{
                            paddingLeft: "2pt",
                            textIndent: "0pt",
                            lineHeight: "10pt",
                            textAlign: "left"
                          }}
                        >
                          4.
                          <span className="s14">MINIMUM PAYMENT (ASSUMED)</span>
                        </p>
                      </td>
                      <td
                        style={{
                          width: "136pt",
                          borderBottomStyle: "solid",
                          borderBottomWidth: "1pt"
                        }}
                      >
                        <p
                          className="s14"
                          style={{
                            paddingLeft: "27pt",
                            textIndent: "0pt",
                            lineHeight: "10pt",
                            textAlign: "left"
                          }}
                        >
                          $ -100.00
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ol id="l47">
                  <li data-list-text={5}>
                    <p
                      className="s22"
                      style={{
                        paddingLeft: "58pt",
                        textIndent: "-17pt",
                        lineHeight: "13pt",
                        textAlign: "left"
                      }}
                    >
                      EXCESS REVENUES $ 850.00
                    </p>
                  </li>
                  <li data-list-text={6}>
                    <p
                      className="s22"
                      style={{
                        paddingLeft: "58pt",
                        textIndent: "-17pt",
                        lineHeight: "13pt",
                        textAlign: "left"
                      }}
                    >
                      EXCESS PMT (E.G. 75% OF EXCESS REVENUES) $ -637.50
                    </p>
                  </li>
                  <li data-list-text={7}>
                    <p
                      className="s22"
                      style={{
                        paddingLeft: "58pt",
                        textIndent: "-17pt",
                        lineHeight: "13pt",
                        textAlign: "left"
                      }}
                    >
                      NET SETTLEMENT TO LESSEE FOR THE WEEK $ 212.50
                    </p>
                  </li>
                  <li data-list-text={8}>
                    <p
                      className="s22"
                      style={{
                        paddingLeft: "58pt",
                        textIndent: "-17pt",
                        lineHeight: "13pt",
                        textAlign: "left"
                      }}
                    >
                      TOTAL PAID AGAINST DEFERRED AMOUNT $ 737.50
                    </p>
                  </li>
                  <li data-list-text={9}>
                    <p
                      className="s22"
                      style={{
                        paddingLeft: "58pt",
                        textIndent: "-17pt",
                        lineHeight: "13pt",
                        textAlign: "left"
                      }}
                    >
                      REMAINING BALANCE OF DEFERRED AMOUNT $ -1762.50
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={3}>
        <h3
          style={{
            paddingLeft: "60pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>EFFECT OF DEFERRED PAYMENT.</u>
          <span className="s22">
            As provided in Section 4(d)(ii) of the Lease Agreement, this Deferment
            Agreement shall defer the due date of such Deferred Amount until the
            earliest of:
          </span>
        </h3>
        <p
          className="s22"
          style={{ paddingLeft: "60pt", textIndent: "0pt", textAlign: "justify" }}
        >
          (A) the occurrence of an Event of Default, at which point the aggregate
          of all such deferred Additional Payments shall be immediately due and
          payable, (B) YOUR termination of this Agreement pursuant to Section 3(b)
          of the Lease Agreement, at which point the aggregate amount of all such
          deferred Additional Payments shall be immediately due and payable, (C)
          the satisfaction of the requirements set forth in Section 18(b) to haul
          for a New Carrier, or (D) the extended due date/s described in Section 2
          above. For the avoidance of doubt, the occurrence of any of the
          foregoing (A), (B), or (C), shall result in the revocation of the terms
          contained in Section 2 above and all available escrow amounts and
          revenues being subject to satisfaction of the obligations under the
          Lease Documents.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={4}>
        <h3
          style={{
            paddingLeft: "60pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>DEFAULT.</u>
          <span className="s22">
            Failure to make timely payments provided herein shall constitute an
            immediate Event of Default under this Deferral Agreement and the Lease
            Agreement.
          </span>
        </h3>
      </li>
      <li data-list-text={5}>
        <h3
          style={{
            paddingTop: "12pt",
            paddingLeft: "60pt",
            textIndent: "-18pt",
            textAlign: "justify"
          }}
        >
          <u>RATIFICATION OF LEASE DOCUMENTS.</u>
          <span className="s22">
            Except as otherwise modified by this Deferral Agreement, all terms,
            provisions, conditions and covenants of the Lease Documents are hereby
            ratified and approved, which remain unchanged and continue in full
            force and effect. Lessee acknowledges (a) that there are no existing
            claims, defenses, personal or otherwise, or rights of setoff
            whatsoever with respect to the Lease Agreement or any other Lease
            Document as of the date hereof, and (b) this Deferral Agreement in no
            way acts as a novation, release, or relinquishment of the rights of
            Lessor under the Lease Agreement or Lease Documents.
          </span>
        </h3>
      </li>
    </ol>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h3 style={{ paddingLeft: "42pt", textIndent: "0pt", textAlign: "left" }}>
      New Horizons Leasing, LLC LESSEE: 7135 Centennial Place
    </h3>
    <h3
      style={{
        paddingLeft: "42pt",
        textIndent: "0pt",
        lineHeight: "13pt",
        textAlign: "left"
      }}
    >
      Nashville, TN 37209
    </h3>
    <p
      style={{
        paddingLeft: "294pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      <span />
    </p>
    <p
      className="s22"
      style={{
        paddingTop: "11pt",
        paddingLeft: "42pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      By:
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      Printed:
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      Title:
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
      Date:
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
    </p>
  </div>


}

export default LeaseAgreementModule;